var map = {
	".": [
		74679
	],
	"./": [
		74679
	],
	"./GeneratedIconNames": [
		52923
	],
	"./GeneratedIconNames.ts": [
		52923
	],
	"./index": [
		74679
	],
	"./index.tsx": [
		74679
	],
	"./svgs/common/1-1-session.svg": [
		54228,
		54228
	],
	"./svgs/common/Pause.svg": [
		39273,
		39273
	],
	"./svgs/common/activity-heart.svg": [
		46690,
		46690
	],
	"./svgs/common/activity.svg": [
		86490,
		86490
	],
	"./svgs/common/affiliate.svg": [
		31717,
		31717
	],
	"./svgs/common/airplay.svg": [
		15937,
		15937
	],
	"./svgs/common/airpods.svg": [
		87660,
		87660
	],
	"./svgs/common/alarm-clock-check.svg": [
		65454,
		25465
	],
	"./svgs/common/alarm-clock-minus.svg": [
		42734,
		42734
	],
	"./svgs/common/alarm-clock-off.svg": [
		42335,
		42335
	],
	"./svgs/common/alarm-clock-plus.svg": [
		60953,
		60953
	],
	"./svgs/common/alarm-clock.svg": [
		93074,
		93074
	],
	"./svgs/common/alert-circle-filled.svg": [
		62917,
		62917
	],
	"./svgs/common/alert-circle.svg": [
		12696,
		12696
	],
	"./svgs/common/align-bottom-02.svg": [
		54911,
		54911
	],
	"./svgs/common/align-center.svg": [
		39947,
		39947
	],
	"./svgs/common/align-horizontal-centre-01.svg": [
		54736,
		65454
	],
	"./svgs/common/align-horizontal-centre-02.svg": [
		1618,
		1618
	],
	"./svgs/common/align-justify.svg": [
		46461,
		46461
	],
	"./svgs/common/align-left-02.svg": [
		80002,
		80002
	],
	"./svgs/common/align-left.svg": [
		41673,
		41673
	],
	"./svgs/common/align-right-02.svg": [
		48141,
		48141
	],
	"./svgs/common/align-right.svg": [
		20181,
		20181
	],
	"./svgs/common/align-top-arrow-02.svg": [
		46810,
		46810
	],
	"./svgs/common/align-vertical-center-01.svg": [
		87899,
		87899
	],
	"./svgs/common/align-vertical-center-02.svg": [
		77144,
		77144
	],
	"./svgs/common/anchor.svg": [
		27594,
		27594
	],
	"./svgs/common/announcement-03.svg": [
		52278,
		52278
	],
	"./svgs/common/archive.svg": [
		95366,
		95366
	],
	"./svgs/common/arrow-circle-down-left.svg": [
		25885,
		25885
	],
	"./svgs/common/arrow-circle-down-right.svg": [
		33918,
		33918
	],
	"./svgs/common/arrow-circle-down.svg": [
		4771,
		4771
	],
	"./svgs/common/arrow-circle-left.svg": [
		92766,
		92766
	],
	"./svgs/common/arrow-circle-right.svg": [
		6920,
		6920
	],
	"./svgs/common/arrow-circle-up-left.svg": [
		35329,
		35329
	],
	"./svgs/common/arrow-circle-up-right.svg": [
		96800,
		96800
	],
	"./svgs/common/arrow-circle-up.svg": [
		15966,
		15966
	],
	"./svgs/common/arrow-down-left.svg": [
		94250,
		94250
	],
	"./svgs/common/arrow-down-right.svg": [
		15781,
		15781
	],
	"./svgs/common/arrow-down.svg": [
		83432,
		83432
	],
	"./svgs/common/arrow-left.svg": [
		12247,
		12247
	],
	"./svgs/common/arrow-right.svg": [
		32762,
		32762
	],
	"./svgs/common/arrow-up-left.svg": [
		48397,
		48397
	],
	"./svgs/common/arrow-up-right.svg": [
		51034,
		51034
	],
	"./svgs/common/arrow-up.svg": [
		81766,
		81766
	],
	"./svgs/common/ataflow-03.svg": [
		44579,
		44579
	],
	"./svgs/common/atom-01.svg": [
		86918,
		86918
	],
	"./svgs/common/attachment-01.svg": [
		46779,
		46779
	],
	"./svgs/common/award-01.svg": [
		9944,
		9944
	],
	"./svgs/common/award-03.svg": [
		75466,
		75466
	],
	"./svgs/common/award-04.svg": [
		54725,
		54725
	],
	"./svgs/common/award-05.svg": [
		81618,
		81618
	],
	"./svgs/common/backpack.svg": [
		23967,
		23967
	],
	"./svgs/common/bank-note-01.svg": [
		81961,
		81961
	],
	"./svgs/common/bank-note-02.svg": [
		6923,
		6923
	],
	"./svgs/common/bank.svg": [
		22698,
		22698
	],
	"./svgs/common/bar-chart-01.svg": [
		98079,
		98079
	],
	"./svgs/common/bar-chart-02.svg": [
		95561,
		95561
	],
	"./svgs/common/bar-chart-03.svg": [
		62601,
		62601
	],
	"./svgs/common/bar-chart-circle-01.svg": [
		90097,
		90097
	],
	"./svgs/common/bar-chart-circle-02.svg": [
		66256,
		66256
	],
	"./svgs/common/bar-chart-circle-03.svg": [
		79813,
		79813
	],
	"./svgs/common/bar-chart-square-01.svg": [
		38471,
		38471
	],
	"./svgs/common/bar-chart-square-02.svg": [
		53036,
		53036
	],
	"./svgs/common/bar-chart-square-03.svg": [
		73298,
		73298
	],
	"./svgs/common/bar-chart-square-down.svg": [
		83622,
		83622
	],
	"./svgs/common/bar-chart-square-minus.svg": [
		78768,
		78768
	],
	"./svgs/common/bar-chart-square-plus.svg": [
		59112,
		59112
	],
	"./svgs/common/bar-chart-square-up.svg": [
		4814,
		4814
	],
	"./svgs/common/bar-line-chart.svg": [
		68297,
		68297
	],
	"./svgs/common/battery-charging-01.svg": [
		51261,
		51261
	],
	"./svgs/common/battery-empty.svg": [
		71746,
		71746
	],
	"./svgs/common/battery-full.svg": [
		19373,
		19373
	],
	"./svgs/common/battery-low.svg": [
		94075,
		61754
	],
	"./svgs/common/battery-mid.svg": [
		99821,
		99821
	],
	"./svgs/common/beaker-01.svg": [
		50962,
		50962
	],
	"./svgs/common/beaker-02.svg": [
		8158,
		8158
	],
	"./svgs/common/bell-01.svg": [
		99110,
		99110
	],
	"./svgs/common/bell-minus.svg": [
		97661,
		97661
	],
	"./svgs/common/bell-off-01.svg": [
		15384,
		15384
	],
	"./svgs/common/bell-plus.svg": [
		90087,
		3834
	],
	"./svgs/common/bell-ringing-01.svg": [
		97960,
		97960
	],
	"./svgs/common/bezier-curve-01.svg": [
		91254,
		91254
	],
	"./svgs/common/bezier-curve-02.svg": [
		96895,
		96895
	],
	"./svgs/common/bezier-curve-03.svg": [
		56392,
		56392
	],
	"./svgs/common/bluetooth-connect.svg": [
		2625,
		2625
	],
	"./svgs/common/bluetooth-on.svg": [
		27323,
		27323
	],
	"./svgs/common/bluetooth-signal.svg": [
		1321,
		1321
	],
	"./svgs/common/bluetooth.svg": [
		4526,
		4526
	],
	"./svgs/common/bold-01.svg": [
		81294,
		81294
	],
	"./svgs/common/book-closed.svg": [
		67748,
		67748
	],
	"./svgs/common/book-open-01.svg": [
		17517,
		17517
	],
	"./svgs/common/bookmark-add.svg": [
		71494,
		71494
	],
	"./svgs/common/bookmark-check.svg": [
		95431,
		95431
	],
	"./svgs/common/bookmark-x.svg": [
		94068,
		94068
	],
	"./svgs/common/bookmark.svg": [
		523,
		523
	],
	"./svgs/common/box.svg": [
		56245,
		56245
	],
	"./svgs/common/brackets-check.svg": [
		42195,
		42195
	],
	"./svgs/common/brackets-minus.svg": [
		39020,
		39020
	],
	"./svgs/common/brackets-slash.svg": [
		8992,
		8992
	],
	"./svgs/common/brackets-x.svg": [
		27900,
		27900
	],
	"./svgs/common/brackets.svg": [
		25846,
		25846
	],
	"./svgs/common/briefcase-02.svg": [
		65994,
		53979
	],
	"./svgs/common/browser.svg": [
		15759,
		15759
	],
	"./svgs/common/brush-01.svg": [
		70097,
		70097
	],
	"./svgs/common/brush-02.svg": [
		21187,
		21187
	],
	"./svgs/common/building-02.svg": [
		4647,
		4647
	],
	"./svgs/common/building-03.svg": [
		21266,
		21266
	],
	"./svgs/common/building-04.svg": [
		59022,
		59022
	],
	"./svgs/common/building-05.svg": [
		95306,
		95306
	],
	"./svgs/common/bus.svg": [
		18181,
		18181
	],
	"./svgs/common/calculator.svg": [
		36374,
		36374
	],
	"./svgs/common/calendar-check-01.svg": [
		87448,
		87448
	],
	"./svgs/common/calendar-date.svg": [
		5317,
		5317
	],
	"./svgs/common/calendar-heart-01.svg": [
		98017,
		98017
	],
	"./svgs/common/calendar-minus-01.svg": [
		91992,
		91992
	],
	"./svgs/common/calendar-money.svg": [
		27928,
		27928
	],
	"./svgs/common/calendar-plus-01.svg": [
		69695,
		69695
	],
	"./svgs/common/calendar-range-01.svg": [
		16331,
		16331
	],
	"./svgs/common/calendar.svg": [
		88314,
		88314
	],
	"./svgs/common/camera-01.svg": [
		88786,
		88786
	],
	"./svgs/common/camera-lens.svg": [
		11585,
		11585
	],
	"./svgs/common/camera-off.svg": [
		7317,
		7317
	],
	"./svgs/common/camera-plus.svg": [
		82431,
		82431
	],
	"./svgs/common/certificate-01.svg": [
		52645,
		52645
	],
	"./svgs/common/chart-breakout-circle.svg": [
		83871,
		83871
	],
	"./svgs/common/check-circle-filled.svg": [
		83580,
		83580
	],
	"./svgs/common/check-circle.svg": [
		95974,
		95974
	],
	"./svgs/common/check-heart.svg": [
		28838,
		28838
	],
	"./svgs/common/check-square.svg": [
		90191,
		90191
	],
	"./svgs/common/check-verified-filled.svg": [
		98422,
		98422
	],
	"./svgs/common/check-verified.svg": [
		19060,
		19060
	],
	"./svgs/common/check.svg": [
		64554,
		64554
	],
	"./svgs/common/chevron-collapse.svg": [
		87611,
		87611
	],
	"./svgs/common/chevron-down-circle.svg": [
		89085,
		89085
	],
	"./svgs/common/chevron-down.svg": [
		84966,
		84966
	],
	"./svgs/common/chevron-left.svg": [
		7458,
		7458
	],
	"./svgs/common/chevron-right.svg": [
		75357,
		75357
	],
	"./svgs/common/chevron-selector-horizontal.svg": [
		6582,
		6582
	],
	"./svgs/common/chevron-selector-vertical.svg": [
		72419,
		72419
	],
	"./svgs/common/chevron-up.svg": [
		4614,
		4614
	],
	"./svgs/common/chrome-cast.svg": [
		85297,
		85297
	],
	"./svgs/common/circle-cut.svg": [
		59870,
		59870
	],
	"./svgs/common/clap-fill.svg": [
		15358,
		86640
	],
	"./svgs/common/clap.svg": [
		48939,
		48939
	],
	"./svgs/common/clipboard-attachment.svg": [
		20506,
		20506
	],
	"./svgs/common/clipboard-check.svg": [
		89976,
		89976
	],
	"./svgs/common/clipboard-download.svg": [
		14308,
		14308
	],
	"./svgs/common/clipboard-minus.svg": [
		36847,
		36847
	],
	"./svgs/common/clipboard-plus.svg": [
		13958,
		13958
	],
	"./svgs/common/clipboard-x.svg": [
		26326,
		26326
	],
	"./svgs/common/clipboard.svg": [
		78188,
		78188
	],
	"./svgs/common/clock-check.svg": [
		82346,
		82346
	],
	"./svgs/common/clock-fast-forward.svg": [
		79513,
		79513
	],
	"./svgs/common/clock-plus.svg": [
		84609,
		84609
	],
	"./svgs/common/clock-refresh.svg": [
		76315,
		76315
	],
	"./svgs/common/clock-rewind.svg": [
		34179,
		34179
	],
	"./svgs/common/clock-snooze.svg": [
		49925,
		49925
	],
	"./svgs/common/clock-stopwatch.svg": [
		96996,
		96996
	],
	"./svgs/common/clock.svg": [
		88693,
		88693
	],
	"./svgs/common/cloud-01.svg": [
		96794,
		96794
	],
	"./svgs/common/cloud-02.svg": [
		7540,
		7540
	],
	"./svgs/common/cloud-03.svg": [
		35641,
		35641
	],
	"./svgs/common/cloud-blank-01.svg": [
		9676,
		9676
	],
	"./svgs/common/cloud-lightning.svg": [
		79281,
		79281
	],
	"./svgs/common/cloud-moon.svg": [
		45079,
		45079
	],
	"./svgs/common/cloud-off.svg": [
		54743,
		54743
	],
	"./svgs/common/cloud-raining-01.svg": [
		40565,
		40565
	],
	"./svgs/common/cloud-raining-02.svg": [
		61941,
		61941
	],
	"./svgs/common/cloud-raining-03.svg": [
		40084,
		40084
	],
	"./svgs/common/cloud-raining-04.svg": [
		17524,
		17524
	],
	"./svgs/common/cloud-raining-05.svg": [
		45283,
		45283
	],
	"./svgs/common/cloud-raining-06.svg": [
		64951,
		64951
	],
	"./svgs/common/cloud-snowing-01.svg": [
		61656,
		61656
	],
	"./svgs/common/cloud-snowing-02.svg": [
		35802,
		35802
	],
	"./svgs/common/cloud-sun-01.svg": [
		65413,
		65413
	],
	"./svgs/common/cloud-sun-02.svg": [
		65555,
		65555
	],
	"./svgs/common/cloud-sun-03.svg": [
		22955,
		22955
	],
	"./svgs/common/code-01.svg": [
		76684,
		76684
	],
	"./svgs/common/code-02.svg": [
		55538,
		55538
	],
	"./svgs/common/code-browser.svg": [
		68369,
		68369
	],
	"./svgs/common/code-circle-01.svg": [
		21776,
		21776
	],
	"./svgs/common/code-circle-02.svg": [
		63277,
		63277
	],
	"./svgs/common/code-circle-03.svg": [
		41396,
		41396
	],
	"./svgs/common/code-square-01.svg": [
		12741,
		12741
	],
	"./svgs/common/code-square-02.svg": [
		96438,
		96438
	],
	"./svgs/common/codepen.svg": [
		1926,
		1926
	],
	"./svgs/common/coins-01.svg": [
		52322,
		52322
	],
	"./svgs/common/coins-02.svg": [
		55018,
		55018
	],
	"./svgs/common/coins-hand.svg": [
		65460,
		65460
	],
	"./svgs/common/coins-stacked-01.svg": [
		82397,
		82397
	],
	"./svgs/common/coins-stacked-03.svg": [
		96067,
		96067
	],
	"./svgs/common/coins-stacked-04.svg": [
		44282,
		44282
	],
	"./svgs/common/coins-swap-02.svg": [
		18051,
		18051
	],
	"./svgs/common/colors.svg": [
		34366,
		34366
	],
	"./svgs/common/columns-02.svg": [
		97784,
		97784
	],
	"./svgs/common/columns-03.svg": [
		79022,
		79022
	],
	"./svgs/common/command.svg": [
		36840,
		36840
	],
	"./svgs/common/compass-01.svg": [
		60339,
		60339
	],
	"./svgs/common/compass.svg": [
		63556,
		63556
	],
	"./svgs/common/container.svg": [
		30782,
		30782
	],
	"./svgs/common/contrast-01.svg": [
		9685,
		9685
	],
	"./svgs/common/contrast-02.svg": [
		32081,
		32081
	],
	"./svgs/common/contrast-03.svg": [
		78210,
		78210
	],
	"./svgs/common/copy.svg": [
		97959,
		97959
	],
	"./svgs/common/cpu-chip-01.svg": [
		64343,
		64343
	],
	"./svgs/common/cpu-chip-02.svg": [
		90930,
		90930
	],
	"./svgs/common/credit-card-02.svg": [
		42204,
		42204
	],
	"./svgs/common/credit-card-check.svg": [
		56405,
		56405
	],
	"./svgs/common/credit-card-down.svg": [
		6774,
		6774
	],
	"./svgs/common/credit-card-download.svg": [
		88124,
		88124
	],
	"./svgs/common/credit-card-edit.svg": [
		21357,
		65994
	],
	"./svgs/common/credit-card-lock.svg": [
		40644,
		40644
	],
	"./svgs/common/credit-card-minus.svg": [
		26140,
		26140
	],
	"./svgs/common/credit-card-plus.svg": [
		49710,
		49710
	],
	"./svgs/common/credit-card-refresh.svg": [
		78645,
		78645
	],
	"./svgs/common/credit-card-search.svg": [
		27584,
		27584
	],
	"./svgs/common/credit-card-shield.svg": [
		88895,
		88895
	],
	"./svgs/common/credit-card-up.svg": [
		92302,
		92302
	],
	"./svgs/common/credit-card-upload.svg": [
		96325,
		96325
	],
	"./svgs/common/credit-card-x.svg": [
		29954,
		29954
	],
	"./svgs/common/crop-01.svg": [
		8155,
		8155
	],
	"./svgs/common/cryptocurrency-01.svg": [
		56763,
		56763
	],
	"./svgs/common/cryptocurrency-02.svg": [
		56864,
		56864
	],
	"./svgs/common/cryptocurrency-03.svg": [
		63721,
		63721
	],
	"./svgs/common/cryptocurrency-04.svg": [
		37489,
		37489
	],
	"./svgs/common/cube-01.svg": [
		67124,
		67124
	],
	"./svgs/common/cube-02.svg": [
		55920,
		55920
	],
	"./svgs/common/cube-03.svg": [
		60857,
		60857
	],
	"./svgs/common/cube-04.svg": [
		50682,
		50682
	],
	"./svgs/common/cube-outline.svg": [
		51401,
		51401
	],
	"./svgs/common/currency-bitcoin-circle.svg": [
		3844,
		3844
	],
	"./svgs/common/currency-bitcoin.svg": [
		84222,
		84222
	],
	"./svgs/common/currency-dollar-circle.svg": [
		35970,
		35970
	],
	"./svgs/common/currency-dollar.svg": [
		68085,
		68085
	],
	"./svgs/common/currency-ethereum-circle.svg": [
		10801,
		10801
	],
	"./svgs/common/currency-ethereum.svg": [
		68219,
		68219
	],
	"./svgs/common/currency-euro-circle.svg": [
		37695,
		37695
	],
	"./svgs/common/currency-euro.svg": [
		84157,
		84157
	],
	"./svgs/common/currency-pound-circle.svg": [
		12426,
		12426
	],
	"./svgs/common/currency-pound.svg": [
		96688,
		96688
	],
	"./svgs/common/currency-ruble-circle.svg": [
		81452,
		81452
	],
	"./svgs/common/currency-ruble.svg": [
		56117,
		56117
	],
	"./svgs/common/currency-rupee-circle.svg": [
		9304,
		9304
	],
	"./svgs/common/currency-rupee.svg": [
		55250,
		55250
	],
	"./svgs/common/currency-yen-circle.svg": [
		33767,
		33767
	],
	"./svgs/common/currency-yen.svg": [
		19536,
		19536
	],
	"./svgs/common/cursor-01.svg": [
		70274,
		70274
	],
	"./svgs/common/cursor-02.svg": [
		29779,
		29779
	],
	"./svgs/common/cursor-04.svg": [
		43941,
		43941
	],
	"./svgs/common/cursor-box.svg": [
		24644,
		24644
	],
	"./svgs/common/cursor-click-01.svg": [
		96341,
		96341
	],
	"./svgs/common/cursor-click-02.svg": [
		80301,
		80301
	],
	"./svgs/common/data.svg": [
		22209,
		22209
	],
	"./svgs/common/database-02.svg": [
		69053,
		51879
	],
	"./svgs/common/database-03.svg": [
		69607,
		69607
	],
	"./svgs/common/dataflow-01.svg": [
		88211,
		88211
	],
	"./svgs/common/dataflow-02.svg": [
		12449,
		12449
	],
	"./svgs/common/dataflow-04.svg": [
		93683,
		93683
	],
	"./svgs/common/delete.svg": [
		44503,
		44503
	],
	"./svgs/common/diamond-01.svg": [
		16993,
		16993
	],
	"./svgs/common/dice-1.svg": [
		35598,
		35598
	],
	"./svgs/common/dice-2.svg": [
		22289,
		22289
	],
	"./svgs/common/dice-3.svg": [
		14819,
		14819
	],
	"./svgs/common/dice-4.svg": [
		21886,
		21886
	],
	"./svgs/common/dice-5.svg": [
		5805,
		5805
	],
	"./svgs/common/dice-6.svg": [
		91668,
		91668
	],
	"./svgs/common/disc-02.svg": [
		32086,
		32086
	],
	"./svgs/common/distribute-spacing-horizontal.svg": [
		77025,
		77025
	],
	"./svgs/common/distribute-spacing-vertical-filled.svg": [
		63922,
		63922
	],
	"./svgs/common/distribute-spacing-vertical.svg": [
		31891,
		31891
	],
	"./svgs/common/divide-01.svg": [
		88649,
		88649
	],
	"./svgs/common/divider.svg": [
		18586,
		18586
	],
	"./svgs/common/dotpoints-01.svg": [
		10687,
		10687
	],
	"./svgs/common/dots-horizontal.svg": [
		33954,
		33954
	],
	"./svgs/common/dots-reorder-drag.svg": [
		81607,
		81607
	],
	"./svgs/common/dots-vertical.svg": [
		18477,
		18477
	],
	"./svgs/common/download-01.svg": [
		77024,
		77024
	],
	"./svgs/common/download-02.svg": [
		40480,
		40480
	],
	"./svgs/common/download-cloud-01.svg": [
		70908,
		70908
	],
	"./svgs/common/drop.svg": [
		91420,
		91420
	],
	"./svgs/common/droplets-01.svg": [
		70092,
		70092
	],
	"./svgs/common/droplets-02.svg": [
		5137,
		5137
	],
	"./svgs/common/droplets-03.svg": [
		66596,
		66596
	],
	"./svgs/common/dropper.svg": [
		61953,
		61953
	],
	"./svgs/common/duplicate.svg": [
		88331,
		88331
	],
	"./svgs/common/edit-04.svg": [
		19131,
		19131
	],
	"./svgs/common/edit.svg": [
		34688,
		34688
	],
	"./svgs/common/eraser.svg": [
		85875,
		85875
	],
	"./svgs/common/expand-01.svg": [
		31683,
		31683
	],
	"./svgs/common/expand-width.svg": [
		75072,
		75072
	],
	"./svgs/common/eye-first.svg": [
		20182,
		20182
	],
	"./svgs/common/eye-off.svg": [
		22027,
		22027
	],
	"./svgs/common/eye-second.svg": [
		19324,
		19324
	],
	"./svgs/common/eye.svg": [
		86154,
		86154
	],
	"./svgs/common/face-frown.svg": [
		99040,
		99040
	],
	"./svgs/common/face-happy.svg": [
		95140,
		95140
	],
	"./svgs/common/face-id.svg": [
		137,
		137
	],
	"./svgs/common/face-neutral.svg": [
		55784,
		55784
	],
	"./svgs/common/face-smile.svg": [
		97603,
		97603
	],
	"./svgs/common/face-wink.svg": [
		11703,
		11703
	],
	"./svgs/common/fast-backward.svg": [
		32106,
		32106
	],
	"./svgs/common/fast-forward.svg": [
		59146,
		59146
	],
	"./svgs/common/feather.svg": [
		47949,
		47949
	],
	"./svgs/common/figma.svg": [
		27027,
		27027
	],
	"./svgs/common/file-01.svg": [
		51672,
		51672
	],
	"./svgs/common/file-02.svg": [
		7787,
		7787
	],
	"./svgs/common/file-03.svg": [
		82013,
		98455
	],
	"./svgs/common/file-attachment-04.svg": [
		2511,
		2511
	],
	"./svgs/common/file-check-01.svg": [
		24441,
		24441
	],
	"./svgs/common/file-code-01.svg": [
		84680,
		84680
	],
	"./svgs/common/file-code-02.svg": [
		47225,
		47225
	],
	"./svgs/common/file-download-01.svg": [
		20551,
		20551
	],
	"./svgs/common/file-heart-01.svg": [
		49016,
		49016
	],
	"./svgs/common/file-lock-03.svg": [
		39570,
		39570
	],
	"./svgs/common/file-minus-01.svg": [
		7070,
		7070
	],
	"./svgs/common/file-plus-01.svg": [
		31629,
		31629
	],
	"./svgs/common/file-question-01.svg": [
		31369,
		31369
	],
	"./svgs/common/file-search-01.svg": [
		31901,
		31901
	],
	"./svgs/common/file-shield-03.svg": [
		28354,
		28354
	],
	"./svgs/common/file-x-01.svg": [
		88257,
		88257
	],
	"./svgs/common/film-01.svg": [
		90501,
		90501
	],
	"./svgs/common/film-02.svg": [
		63979,
		63979
	],
	"./svgs/common/filter-funnel-01.svg": [
		97449,
		97449
	],
	"./svgs/common/filter-lines.svg": [
		48731,
		48731
	],
	"./svgs/common/fingerprint-03.svg": [
		17257,
		17257
	],
	"./svgs/common/flag-01.svg": [
		20072,
		11285
	],
	"./svgs/common/flag-02.svg": [
		41869,
		6525
	],
	"./svgs/common/flash-off.svg": [
		39068,
		39068
	],
	"./svgs/common/flash.svg": [
		8165,
		8165
	],
	"./svgs/common/flex-align-bottom.svg": [
		66471,
		66471
	],
	"./svgs/common/flex-align-left.svg": [
		10509,
		10509
	],
	"./svgs/common/flex-align-right.svg": [
		20809,
		20809
	],
	"./svgs/common/flex-align-top.svg": [
		66361,
		66361
	],
	"./svgs/common/flip-backward.svg": [
		98624,
		98624
	],
	"./svgs/common/flip-forward.svg": [
		65063,
		52333
	],
	"./svgs/common/folder-check.svg": [
		54885,
		54885
	],
	"./svgs/common/folder-closed.svg": [
		77547,
		77547
	],
	"./svgs/common/folder-code.svg": [
		30005,
		30005
	],
	"./svgs/common/folder-download.svg": [
		45144,
		45144
	],
	"./svgs/common/folder-lock.svg": [
		4365,
		4365
	],
	"./svgs/common/folder-minus.svg": [
		7588,
		7588
	],
	"./svgs/common/folder-plus.svg": [
		61488,
		61488
	],
	"./svgs/common/folder-question.svg": [
		92506,
		92506
	],
	"./svgs/common/folder-search.svg": [
		90161,
		90161
	],
	"./svgs/common/folder-shield.svg": [
		64334,
		64334
	],
	"./svgs/common/folder-x.svg": [
		70607,
		70607
	],
	"./svgs/common/folder.svg": [
		64787,
		64787
	],
	"./svgs/common/framer.svg": [
		79290,
		79290
	],
	"./svgs/common/gaming-pad-01.svg": [
		90485,
		90485
	],
	"./svgs/common/gift-01.svg": [
		46812,
		46812
	],
	"./svgs/common/git-branch-01.svg": [
		29953,
		29953
	],
	"./svgs/common/git-branch-02.svg": [
		64031,
		64031
	],
	"./svgs/common/git-commit.svg": [
		75009,
		75009
	],
	"./svgs/common/git-merge.svg": [
		85703,
		85703
	],
	"./svgs/common/git-pull-request.svg": [
		54566,
		54566
	],
	"./svgs/common/glasses-01.svg": [
		64919,
		64919
	],
	"./svgs/common/glasses-02.svg": [
		10978,
		10978
	],
	"./svgs/common/globe-02.svg": [
		92507,
		92507
	],
	"./svgs/common/globe-04.svg": [
		45387,
		45387
	],
	"./svgs/common/globe-05.svg": [
		34237,
		34237
	],
	"./svgs/common/globe-06.svg": [
		33495,
		33495
	],
	"./svgs/common/globe-search-02.svg": [
		88328,
		88328
	],
	"./svgs/common/graduation-hat-01.svg": [
		79560,
		79560
	],
	"./svgs/common/graduation-hat-02.svg": [
		19456,
		19456
	],
	"./svgs/common/grid-01.svg": [
		14794,
		14794
	],
	"./svgs/common/grid-02.svg": [
		16811,
		16811
	],
	"./svgs/common/grid-03.svg": [
		41293,
		41293
	],
	"./svgs/common/grid.svg": [
		37261,
		37261
	],
	"./svgs/common/h1.svg": [
		57082,
		57082
	],
	"./svgs/common/h2.svg": [
		9555,
		9555
	],
	"./svgs/common/h3.svg": [
		35953,
		35953
	],
	"./svgs/common/hand.svg": [
		33108,
		33108
	],
	"./svgs/common/hard-drive.svg": [
		38385,
		38385
	],
	"./svgs/common/hash-01.svg": [
		32824,
		32824
	],
	"./svgs/common/hash-02.svg": [
		97684,
		97684
	],
	"./svgs/common/heading-01.svg": [
		18276,
		18276
	],
	"./svgs/common/headphones-01.svg": [
		82230,
		82230
	],
	"./svgs/common/headphones-02.svg": [
		80637,
		80637
	],
	"./svgs/common/heart-circle.svg": [
		57134,
		57134
	],
	"./svgs/common/heart-filled.svg": [
		68366,
		68366
	],
	"./svgs/common/heart-hand.svg": [
		88251,
		88251
	],
	"./svgs/common/heart-hide.svg": [
		59529,
		59529
	],
	"./svgs/common/heart.svg": [
		82331,
		82331
	],
	"./svgs/common/help-circle.svg": [
		62254,
		62254
	],
	"./svgs/common/hexagon-01.svg": [
		38113,
		38113
	],
	"./svgs/common/hexagon-02.svg": [
		3946,
		3946
	],
	"./svgs/common/hield-03.svg": [
		15125,
		15125
	],
	"./svgs/common/home-smile.svg": [
		54949,
		54949
	],
	"./svgs/common/home.svg": [
		35759,
		35759
	],
	"./svgs/common/hone-01.svg": [
		53051,
		53051
	],
	"./svgs/common/hourglass-01.svg": [
		82888,
		82888
	],
	"./svgs/common/hourglass-03.svg": [
		74520,
		74520
	],
	"./svgs/common/hurricane-01.svg": [
		74554,
		74554
	],
	"./svgs/common/hurricane-02.svg": [
		40359,
		40359
	],
	"./svgs/common/hurricane-03.svg": [
		79275,
		79275
	],
	"./svgs/common/image-01.svg": [
		76752,
		76752
	],
	"./svgs/common/image-check.svg": [
		40917,
		40917
	],
	"./svgs/common/image-down.svg": [
		71733,
		71733
	],
	"./svgs/common/image-indent-left.svg": [
		72000,
		72000
	],
	"./svgs/common/image-indent-right.svg": [
		68118,
		68118
	],
	"./svgs/common/image-left.svg": [
		63354,
		63354
	],
	"./svgs/common/image-plus.svg": [
		4542,
		4542
	],
	"./svgs/common/image-right.svg": [
		83575,
		83575
	],
	"./svgs/common/image-up.svg": [
		86083,
		86083
	],
	"./svgs/common/image-user-check.svg": [
		824,
		824
	],
	"./svgs/common/image-user-down.svg": [
		40843,
		40843
	],
	"./svgs/common/image-user-left.svg": [
		82064,
		82064
	],
	"./svgs/common/image-user-plus.svg": [
		15315,
		15315
	],
	"./svgs/common/image-user-right.svg": [
		73875,
		73875
	],
	"./svgs/common/image-user-up.svg": [
		64461,
		64461
	],
	"./svgs/common/image-user-x.svg": [
		47884,
		47884
	],
	"./svgs/common/image-user.svg": [
		5906,
		5906
	],
	"./svgs/common/image-x.svg": [
		57976,
		57976
	],
	"./svgs/common/inbox-01.svg": [
		69563,
		69563
	],
	"./svgs/common/infinity.svg": [
		33962,
		33962
	],
	"./svgs/common/info-circle-filled.svg": [
		23439,
		23439
	],
	"./svgs/common/info-circle.svg": [
		28187,
		28187
	],
	"./svgs/common/intersect-circle.svg": [
		10229,
		10229
	],
	"./svgs/common/intersect-square.svg": [
		64602,
		64602
	],
	"./svgs/common/italic-01.svg": [
		49112,
		49112
	],
	"./svgs/common/key-01.svg": [
		48502,
		48502
	],
	"./svgs/common/keyboard-02.svg": [
		80050,
		80050
	],
	"./svgs/common/keyboard-dismiss.svg": [
		80732,
		80732
	],
	"./svgs/common/keyboard-show.svg": [
		1297,
		1297
	],
	"./svgs/common/laptop-02.svg": [
		82048,
		82048
	],
	"./svgs/common/layer-single.svg": [
		55566,
		55566
	],
	"./svgs/common/layers-three-01.svg": [
		70730,
		70730
	],
	"./svgs/common/layers-three-02.svg": [
		67048,
		67048
	],
	"./svgs/common/layers-two-01.svg": [
		15124,
		15124
	],
	"./svgs/common/layers-two-02.svg": [
		9518,
		9518
	],
	"./svgs/common/layout-alt-01.svg": [
		50194,
		50194
	],
	"./svgs/common/layout-alt-02.svg": [
		43736,
		43736
	],
	"./svgs/common/layout-alt-03.svg": [
		33567,
		14569
	],
	"./svgs/common/layout-alt-04.svg": [
		23061,
		23061
	],
	"./svgs/common/layout-bottom.svg": [
		56454,
		56454
	],
	"./svgs/common/layout-grid-01.svg": [
		17657,
		17657
	],
	"./svgs/common/layout-grid-02.svg": [
		70537,
		70537
	],
	"./svgs/common/layout-left.svg": [
		94487,
		94487
	],
	"./svgs/common/layout-right-filled.svg": [
		33114,
		33114
	],
	"./svgs/common/layout-right.svg": [
		66701,
		66701
	],
	"./svgs/common/layout-top.svg": [
		93532,
		93532
	],
	"./svgs/common/left-indent-01.svg": [
		20960,
		20960
	],
	"./svgs/common/left-indent-02.svg": [
		95651,
		95651
	],
	"./svgs/common/letter-spacing-01.svg": [
		70285,
		70285
	],
	"./svgs/common/letter-spacing-02.svg": [
		99418,
		99418
	],
	"./svgs/common/lightbulb-01.svg": [
		11625,
		11625
	],
	"./svgs/common/lightbulb-02.svg": [
		57296,
		57296
	],
	"./svgs/common/lightning-01.svg": [
		12240,
		12240
	],
	"./svgs/common/lightning-02.svg": [
		53684,
		53684
	],
	"./svgs/common/lightning-filled-01.svg": [
		12310,
		12310
	],
	"./svgs/common/line-chart-down-02.svg": [
		14813,
		14813
	],
	"./svgs/common/line-chart-down-03.svg": [
		64408,
		64408
	],
	"./svgs/common/line-chart-up-02.svg": [
		25523,
		25523
	],
	"./svgs/common/line-chart-up-03.svg": [
		2985,
		2985
	],
	"./svgs/common/line-height.svg": [
		31277,
		31277
	],
	"./svgs/common/link-01.svg": [
		25170,
		25170
	],
	"./svgs/common/link-broken-02.svg": [
		60544,
		60544
	],
	"./svgs/common/link-external-01.svg": [
		58250,
		58250
	],
	"./svgs/common/loading-01.svg": [
		34777,
		34777
	],
	"./svgs/common/loading-02.svg": [
		37066,
		37066
	],
	"./svgs/common/lock-01.svg": [
		4546,
		4546
	],
	"./svgs/common/lock-03.svg": [
		22652,
		22652
	],
	"./svgs/common/lock-keyhole-circle.svg": [
		51486,
		51486
	],
	"./svgs/common/lock-keyhole-square.svg": [
		62578,
		62578
	],
	"./svgs/common/lock-unlocked-01.svg": [
		92837,
		92837
	],
	"./svgs/common/log-in.svg": [
		68124,
		68124
	],
	"./svgs/common/log-out.svg": [
		39608,
		39608
	],
	"./svgs/common/luggage-01.svg": [
		90796,
		90796
	],
	"./svgs/common/luggage-03.svg": [
		12019,
		12019
	],
	"./svgs/common/magic-wand-01.svg": [
		1849,
		1849
	],
	"./svgs/common/magic-wand-02.svg": [
		10544,
		10544
	],
	"./svgs/common/mail-01.svg": [
		67146,
		67146
	],
	"./svgs/common/mail-04.svg": [
		30705,
		30705
	],
	"./svgs/common/map-01.svg": [
		69329,
		69329
	],
	"./svgs/common/mark.svg": [
		38155,
		38155
	],
	"./svgs/common/marker-pin-01.svg": [
		93923,
		93923
	],
	"./svgs/common/marker-pin-04.svg": [
		35733,
		35733
	],
	"./svgs/common/marker-pin-05.svg": [
		92629,
		92629
	],
	"./svgs/common/marker-pin-06.svg": [
		15876,
		15876
	],
	"./svgs/common/maximize-01.svg": [
		37280,
		37280
	],
	"./svgs/common/maximize-02.svg": [
		31242,
		31242
	],
	"./svgs/common/medical-circle.svg": [
		53883,
		53883
	],
	"./svgs/common/medical-cross.svg": [
		50515,
		50515
	],
	"./svgs/common/menu-01.svg": [
		26117,
		26117
	],
	"./svgs/common/menu-02.svg": [
		36135,
		36135
	],
	"./svgs/common/menu-close-01.svg": [
		59074,
		59074
	],
	"./svgs/common/message-alert-square.svg": [
		19494,
		19494
	],
	"./svgs/common/message-chat-circle.svg": [
		76178,
		76178
	],
	"./svgs/common/message-chat-square.svg": [
		79100,
		79100
	],
	"./svgs/common/message-check-square.svg": [
		90681,
		90681
	],
	"./svgs/common/message-circle-02.svg": [
		60976,
		60976
	],
	"./svgs/common/message-dots-square.svg": [
		11395,
		11395
	],
	"./svgs/common/message-heart-square.svg": [
		37146,
		37146
	],
	"./svgs/common/message-notification-square.svg": [
		48316,
		48316
	],
	"./svgs/common/message-plus-square.svg": [
		73017,
		73017
	],
	"./svgs/common/message-question-square.svg": [
		84261,
		84261
	],
	"./svgs/common/message-smile-square.svg": [
		47417,
		47417
	],
	"./svgs/common/message-square-02.svg": [
		38904,
		38904
	],
	"./svgs/common/message-square-filled-02.svg": [
		59872,
		59872
	],
	"./svgs/common/message-text-square-02.svg": [
		27781,
		27781
	],
	"./svgs/common/message-x-square.svg": [
		98372,
		98372
	],
	"./svgs/common/microphone-01.svg": [
		54603,
		54603
	],
	"./svgs/common/microphone-off-01.svg": [
		82584,
		82584
	],
	"./svgs/common/microscope.svg": [
		15819,
		15819
	],
	"./svgs/common/minimize-01.svg": [
		13114,
		13114
	],
	"./svgs/common/minimize-02.svg": [
		56711,
		56711
	],
	"./svgs/common/minus-circle.svg": [
		47503,
		47503
	],
	"./svgs/common/minus.svg": [
		5429,
		5429
	],
	"./svgs/common/monitor-01.svg": [
		57713,
		57713
	],
	"./svgs/common/monitor-03.svg": [
		40344,
		40344
	],
	"./svgs/common/monitor-05.svg": [
		25912,
		25912
	],
	"./svgs/common/moon-01.svg": [
		78660,
		78660
	],
	"./svgs/common/moon-02.svg": [
		42043,
		42043
	],
	"./svgs/common/moon-eclipse.svg": [
		9800,
		9800
	],
	"./svgs/common/moon-star.svg": [
		20929,
		20929
	],
	"./svgs/common/mouse.svg": [
		44883,
		44883
	],
	"./svgs/common/move.svg": [
		21379,
		21379
	],
	"./svgs/common/music-note-01.svg": [
		60699,
		60699
	],
	"./svgs/common/music-note-02.svg": [
		40640,
		40640
	],
	"./svgs/common/music.svg": [
		68867,
		68867
	],
	"./svgs/common/navigation-pointer-01.svg": [
		43072,
		43072
	],
	"./svgs/common/navigation-pointer-02.svg": [
		62005,
		62801
	],
	"./svgs/common/navigation-pointer-off-01.svg": [
		89238,
		89238
	],
	"./svgs/common/navigation-pointer-off-02.svg": [
		56176,
		56176
	],
	"./svgs/common/notification-box.svg": [
		66581,
		66581
	],
	"./svgs/common/notification-text.svg": [
		92197,
		9412
	],
	"./svgs/common/number-list.svg": [
		39537,
		39537
	],
	"./svgs/common/octagon.svg": [
		7569,
		7569
	],
	"./svgs/common/package-check.svg": [
		9132,
		9132
	],
	"./svgs/common/package-minus.svg": [
		65909,
		65909
	],
	"./svgs/common/package-plus.svg": [
		46267,
		46267
	],
	"./svgs/common/package-search.svg": [
		24525,
		24525
	],
	"./svgs/common/package-x.svg": [
		80104,
		80104
	],
	"./svgs/common/package.svg": [
		63269,
		63269
	],
	"./svgs/common/paint-pour.svg": [
		98633,
		98633
	],
	"./svgs/common/paint.svg": [
		20752,
		20752
	],
	"./svgs/common/palette.svg": [
		99443,
		99443
	],
	"./svgs/common/paperclip.svg": [
		31625,
		31625
	],
	"./svgs/common/paragraph-spacing.svg": [
		47310,
		47310
	],
	"./svgs/common/paragraph-wrap.svg": [
		83933,
		83933
	],
	"./svgs/common/passcode-lock.svg": [
		27784,
		27784
	],
	"./svgs/common/passcode.svg": [
		85939,
		85939
	],
	"./svgs/common/passport.svg": [
		29981,
		29981
	],
	"./svgs/common/pause-circle.svg": [
		94621,
		94621
	],
	"./svgs/common/pause-square.svg": [
		65675,
		65675
	],
	"./svgs/common/payment-upi.svg": [
		30543,
		30543
	],
	"./svgs/common/pen-tool-02.svg": [
		27270,
		27270
	],
	"./svgs/common/pen-tool-minus.svg": [
		39049,
		39049
	],
	"./svgs/common/pen-tool-plus.svg": [
		76521,
		76521
	],
	"./svgs/common/pencil-01.svg": [
		13950,
		13950
	],
	"./svgs/common/pencil-line.svg": [
		25850,
		25850
	],
	"./svgs/common/pentagon.svg": [
		11308,
		11308
	],
	"./svgs/common/percent-01.svg": [
		35987,
		35987
	],
	"./svgs/common/percent-03.svg": [
		64032,
		64032
	],
	"./svgs/common/perspective-01.svg": [
		20386,
		20386
	],
	"./svgs/common/perspective-02.svg": [
		74139,
		74139
	],
	"./svgs/common/phone-call-01.svg": [
		47088,
		47088
	],
	"./svgs/common/phone-hang-up.svg": [
		44248,
		44248
	],
	"./svgs/common/phone-incoming-02.svg": [
		23917,
		23917
	],
	"./svgs/common/phone-outgoing-02.svg": [
		75958,
		75958
	],
	"./svgs/common/phone-plus.svg": [
		95097,
		95097
	],
	"./svgs/common/phone-x.svg": [
		71378,
		71378
	],
	"./svgs/common/phone.svg": [
		98090,
		98090
	],
	"./svgs/common/pie-chart-01.svg": [
		72344,
		72344
	],
	"./svgs/common/pie-chart-02.svg": [
		36792,
		36792
	],
	"./svgs/common/pie-chart-03.svg": [
		86445,
		86445
	],
	"./svgs/common/piggy-bank-01.svg": [
		10179,
		10179
	],
	"./svgs/common/pilcrow-01.svg": [
		34114,
		34114
	],
	"./svgs/common/pin-filled.svg": [
		34335,
		34335
	],
	"./svgs/common/pin.svg": [
		23585,
		23585
	],
	"./svgs/common/placeholder.svg": [
		70246,
		70246
	],
	"./svgs/common/plane.svg": [
		53890,
		53890
	],
	"./svgs/common/play-circle.svg": [
		13591,
		13591
	],
	"./svgs/common/play-filled.svg": [
		14217,
		14217
	],
	"./svgs/common/play-square.svg": [
		32270,
		32270
	],
	"./svgs/common/play.svg": [
		49066,
		49066
	],
	"./svgs/common/plus-circle.svg": [
		78075,
		78075
	],
	"./svgs/common/plus.svg": [
		16362,
		16362
	],
	"./svgs/common/podcast.svg": [
		75471,
		75471
	],
	"./svgs/common/podium.svg": [
		64281,
		64281
	],
	"./svgs/common/power-01.svg": [
		29791,
		29791
	],
	"./svgs/common/power-02.svg": [
		51956,
		51956
	],
	"./svgs/common/presentation-chart-01.svg": [
		34489,
		34489
	],
	"./svgs/common/printer.svg": [
		60515,
		60515
	],
	"./svgs/common/public-page.svg": [
		660,
		660
	],
	"./svgs/common/puzzle-piece-02.svg": [
		87150,
		87150
	],
	"./svgs/common/puzzle-piece.svg": [
		43063,
		43063
	],
	"./svgs/common/qr-code-02.svg": [
		6687,
		6687
	],
	"./svgs/common/rackets-ellipses.svg": [
		72711,
		72711
	],
	"./svgs/common/rackets-plus.svg": [
		25769,
		25769
	],
	"./svgs/common/razorpay.svg": [
		21274,
		21274
	],
	"./svgs/common/receipt-check.svg": [
		9000,
		9000
	],
	"./svgs/common/receipt.svg": [
		24877,
		24877
	],
	"./svgs/common/recording-01.svg": [
		45021,
		45021
	],
	"./svgs/common/recording-02.svg": [
		2155,
		2155
	],
	"./svgs/common/recording-03.svg": [
		8234,
		8234
	],
	"./svgs/common/reduce-width.svg": [
		16226,
		16226
	],
	"./svgs/common/reflect-01.svg": [
		73919,
		73919
	],
	"./svgs/common/reflect-02.svg": [
		60017,
		60017
	],
	"./svgs/common/refresh-ccw-01.svg": [
		98749,
		98749
	],
	"./svgs/common/refresh-cw-01.svg": [
		45425,
		45425
	],
	"./svgs/common/refresh-cw-04.svg": [
		53248,
		53248
	],
	"./svgs/common/refresh-cw-05.svg": [
		77,
		77
	],
	"./svgs/common/reorder.svg": [
		3866,
		3866
	],
	"./svgs/common/repeat-01.svg": [
		55489,
		55489
	],
	"./svgs/common/repeat-02.svg": [
		40423,
		40423
	],
	"./svgs/common/right-indent-01.svg": [
		47741,
		47741
	],
	"./svgs/common/right-indent-02.svg": [
		2889,
		2889
	],
	"./svgs/common/rocket-02.svg": [
		72971,
		72971
	],
	"./svgs/common/roller-brush.svg": [
		83546,
		83546
	],
	"./svgs/common/route.svg": [
		65584,
		65584
	],
	"./svgs/common/rows-01.svg": [
		6263,
		6263
	],
	"./svgs/common/rows-02.svg": [
		65312,
		65312
	],
	"./svgs/common/rows-03.svg": [
		48472,
		48472
	],
	"./svgs/common/rss-01.svg": [
		13983,
		13983
	],
	"./svgs/common/ruler.svg": [
		44340,
		44340
	],
	"./svgs/common/safe.svg": [
		25870,
		25870
	],
	"./svgs/common/sale-01.svg": [
		81999,
		81999
	],
	"./svgs/common/sale-02.svg": [
		27484,
		27484
	],
	"./svgs/common/save-01.svg": [
		90676,
		90676
	],
	"./svgs/common/scale-01.svg": [
		6747,
		6747
	],
	"./svgs/common/scale-02.svg": [
		45688,
		45688
	],
	"./svgs/common/scale-03.svg": [
		683,
		683
	],
	"./svgs/common/scales-02.svg": [
		39503,
		39503
	],
	"./svgs/common/scan.svg": [
		66322,
		66322
	],
	"./svgs/common/scissors-01.svg": [
		10354,
		10354
	],
	"./svgs/common/scissors-cut-01.svg": [
		48285,
		48285
	],
	"./svgs/common/search-md.svg": [
		12998,
		12998
	],
	"./svgs/common/send-01.svg": [
		36855,
		36855
	],
	"./svgs/common/send-03.svg": [
		68754,
		68754
	],
	"./svgs/common/send-first-01.svg": [
		70734,
		70734
	],
	"./svgs/common/send-magic-01.svg": [
		62312,
		62312
	],
	"./svgs/common/send-magic-03.svg": [
		31207,
		31207
	],
	"./svgs/common/send-second-01.svg": [
		15936,
		15936
	],
	"./svgs/common/server-01.svg": [
		16252,
		65063
	],
	"./svgs/common/server-02.svg": [
		6619,
		6619
	],
	"./svgs/common/server-03.svg": [
		11214,
		11214
	],
	"./svgs/common/server-04.svg": [
		56396,
		56396
	],
	"./svgs/common/server-05.svg": [
		80619,
		80619
	],
	"./svgs/common/server-06.svg": [
		87901,
		87901
	],
	"./svgs/common/settings-01.svg": [
		73634,
		73634
	],
	"./svgs/common/settings-04.svg": [
		11823,
		11823
	],
	"./svgs/common/share-01.svg": [
		81512,
		81512
	],
	"./svgs/common/share-android.svg": [
		64591,
		64591
	],
	"./svgs/common/share-forward.svg": [
		64957,
		64957
	],
	"./svgs/common/shield-01.svg": [
		77189,
		1539
	],
	"./svgs/common/shield-dollar.svg": [
		40949,
		40949
	],
	"./svgs/common/shield-off.svg": [
		85816,
		85816
	],
	"./svgs/common/shield-plus.svg": [
		83624,
		83624
	],
	"./svgs/common/shield-tick.svg": [
		46147,
		46147
	],
	"./svgs/common/shield-zap.svg": [
		95447,
		95447
	],
	"./svgs/common/shopping-bag-01.svg": [
		55049,
		55049
	],
	"./svgs/common/shopping-bag-02.svg": [
		24105,
		24105
	],
	"./svgs/common/shopping-cart-01.svg": [
		71364,
		71364
	],
	"./svgs/common/shuffle-01.svg": [
		26028,
		26028
	],
	"./svgs/common/signal-01.svg": [
		97006,
		97006
	],
	"./svgs/common/signal-02.svg": [
		1363,
		1363
	],
	"./svgs/common/signal-03.svg": [
		51059,
		51059
	],
	"./svgs/common/simcard.svg": [
		70774,
		70774
	],
	"./svgs/common/skew.svg": [
		18747,
		18747
	],
	"./svgs/common/skip-back.svg": [
		91035,
		91035
	],
	"./svgs/common/skip-forward.svg": [
		63972,
		63972
	],
	"./svgs/common/slash-circle-01.svg": [
		55497,
		55497
	],
	"./svgs/common/sliders-01.svg": [
		17473,
		17473
	],
	"./svgs/common/snowflake-01.svg": [
		28167,
		28167
	],
	"./svgs/common/snowflake-02.svg": [
		72634,
		72634
	],
	"./svgs/common/spacing-height-01.svg": [
		53252,
		53252
	],
	"./svgs/common/spacing-height-02.svg": [
		50218,
		50218
	],
	"./svgs/common/spacing-width-01.svg": [
		95458,
		95458
	],
	"./svgs/common/spacing-width-02.svg": [
		31719,
		31719
	],
	"./svgs/common/speaker-01.svg": [
		81932,
		81932
	],
	"./svgs/common/speaker-02.svg": [
		88206,
		88206
	],
	"./svgs/common/speedometer-01.svg": [
		99839,
		99839
	],
	"./svgs/common/speedometer-03.svg": [
		85278,
		85278
	],
	"./svgs/common/spinning-wheel.svg": [
		95769,
		95769
	],
	"./svgs/common/square.svg": [
		88561,
		88561
	],
	"./svgs/common/stand.svg": [
		30857,
		30857
	],
	"./svgs/common/star-04.svg": [
		64062,
		64062
	],
	"./svgs/common/star-05.svg": [
		35279,
		35279
	],
	"./svgs/common/star-06.svg": [
		65618,
		65618
	],
	"./svgs/common/star-07.svg": [
		29795,
		29795
	],
	"./svgs/common/stars-01.svg": [
		54173,
		54173
	],
	"./svgs/common/stars-02.svg": [
		49289,
		49289
	],
	"./svgs/common/stars-03.svg": [
		85390,
		85390
	],
	"./svgs/common/stars-filled-01.svg": [
		62630,
		62630
	],
	"./svgs/common/stars-filled-02.svg": [
		98204,
		98204
	],
	"./svgs/common/sticker-circle.svg": [
		23540,
		23540
	],
	"./svgs/common/sticker-square.svg": [
		69996,
		69996
	],
	"./svgs/common/stop-circle.svg": [
		75136,
		75136
	],
	"./svgs/common/stop-filled.svg": [
		63887,
		63887
	],
	"./svgs/common/stop-square.svg": [
		21813,
		21813
	],
	"./svgs/common/stop.svg": [
		15572,
		15572
	],
	"./svgs/common/strikethrough-01.svg": [
		6849,
		6849
	],
	"./svgs/common/subscript.svg": [
		35673,
		35673
	],
	"./svgs/common/sun-setting-01.svg": [
		79166,
		79166
	],
	"./svgs/common/sun-setting-03.svg": [
		30237,
		30237
	],
	"./svgs/common/sun.svg": [
		95013,
		95013
	],
	"./svgs/common/sunrise.svg": [
		80858,
		80858
	],
	"./svgs/common/sunset.svg": [
		6194,
		6194
	],
	"./svgs/common/switch-horizontal-01.svg": [
		37407,
		37407
	],
	"./svgs/common/switch-horizontal-02.svg": [
		13710,
		13710
	],
	"./svgs/common/switch-vertical-01.svg": [
		90495,
		90495
	],
	"./svgs/common/switch-vertical-02.svg": [
		47935,
		47935
	],
	"./svgs/common/table.svg": [
		13687,
		13687
	],
	"./svgs/common/tablet-01.svg": [
		20177,
		20177
	],
	"./svgs/common/tag-01.svg": [
		78512,
		78512
	],
	"./svgs/common/target-02.svg": [
		56517,
		56517
	],
	"./svgs/common/target-04.svg": [
		42253,
		42253
	],
	"./svgs/common/telescope.svg": [
		59548,
		59548
	],
	"./svgs/common/terminal-browser.svg": [
		63658,
		63658
	],
	"./svgs/common/terminal-circle.svg": [
		24567,
		24567
	],
	"./svgs/common/terminal-square.svg": [
		31898,
		31898
	],
	"./svgs/common/terminal.svg": [
		10419,
		10419
	],
	"./svgs/common/text-input.svg": [
		43503,
		43503
	],
	"./svgs/common/thermometer-01.svg": [
		44868,
		44868
	],
	"./svgs/common/thermometer-02.svg": [
		13551,
		13551
	],
	"./svgs/common/thermometer-03.svg": [
		44698,
		44698
	],
	"./svgs/common/thermometer-cold.svg": [
		16230,
		16230
	],
	"./svgs/common/thermometer-warm.svg": [
		57989,
		57989
	],
	"./svgs/common/thumbs-down.svg": [
		22588,
		22588
	],
	"./svgs/common/thumbs-up.svg": [
		94087,
		94087
	],
	"./svgs/common/tick.svg": [
		47158,
		47158
	],
	"./svgs/common/ticket-01.svg": [
		76759,
		76759
	],
	"./svgs/common/token-gate.svg": [
		95694,
		95694
	],
	"./svgs/common/tool-01.svg": [
		94894,
		94894
	],
	"./svgs/common/tool-02.svg": [
		15022,
		15022
	],
	"./svgs/common/train.svg": [
		6668,
		6668
	],
	"./svgs/common/tram.svg": [
		96261,
		96261
	],
	"./svgs/common/transform.svg": [
		68469,
		40522
	],
	"./svgs/common/translate-01.svg": [
		66805,
		66805
	],
	"./svgs/common/trash-01.svg": [
		78225,
		78225
	],
	"./svgs/common/trend-down-01.svg": [
		17785,
		17785
	],
	"./svgs/common/trend-up-01.svg": [
		47311,
		47311
	],
	"./svgs/common/triangle.svg": [
		33439,
		80531
	],
	"./svgs/common/trophy-01.svg": [
		12737,
		12737
	],
	"./svgs/common/truck-02.svg": [
		25219,
		25219
	],
	"./svgs/common/tv-02.svg": [
		18258,
		18258
	],
	"./svgs/common/type-01.svg": [
		17540,
		17540
	],
	"./svgs/common/type-strikethrough-01.svg": [
		25468,
		25468
	],
	"./svgs/common/umbrella-02.svg": [
		74876,
		74876
	],
	"./svgs/common/umbrella-03.svg": [
		44565,
		44565
	],
	"./svgs/common/underline-01.svg": [
		63871,
		63871
	],
	"./svgs/common/unfeature.svg": [
		33391,
		33391
	],
	"./svgs/common/unpin-filled.svg": [
		10151,
		10151
	],
	"./svgs/common/unpin.svg": [
		82248,
		82248
	],
	"./svgs/common/upload-cloud-01.svg": [
		26446,
		26446
	],
	"./svgs/common/usb-flash-drive.svg": [
		36339,
		36339
	],
	"./svgs/common/user-01.svg": [
		6133,
		6133
	],
	"./svgs/common/user-check-01.svg": [
		60980,
		60980
	],
	"./svgs/common/user-circle.svg": [
		34561,
		34561
	],
	"./svgs/common/user-down-01.svg": [
		2854,
		2854
	],
	"./svgs/common/user-edit.svg": [
		85564,
		85564
	],
	"./svgs/common/user-left-01.svg": [
		25869,
		25869
	],
	"./svgs/common/user-minus-01.svg": [
		97106,
		97106
	],
	"./svgs/common/user-money.svg": [
		7452,
		7452
	],
	"./svgs/common/user-plus-01.svg": [
		89122,
		89122
	],
	"./svgs/common/user-right-01.svg": [
		47243,
		47243
	],
	"./svgs/common/user-square.svg": [
		1352,
		1352
	],
	"./svgs/common/user-up-01.svg": [
		50700,
		50700
	],
	"./svgs/common/user-x-01.svg": [
		91672,
		91672
	],
	"./svgs/common/users-01.svg": [
		59913,
		59913
	],
	"./svgs/common/users-check.svg": [
		58369,
		58369
	],
	"./svgs/common/users-download.svg": [
		70618,
		70618
	],
	"./svgs/common/users-edit.svg": [
		82747,
		13572
	],
	"./svgs/common/users-left.svg": [
		98080,
		98080
	],
	"./svgs/common/users-minus.svg": [
		69561,
		69561
	],
	"./svgs/common/users-money.svg": [
		20316,
		20316
	],
	"./svgs/common/users-plus.svg": [
		60645,
		60645
	],
	"./svgs/common/users-right.svg": [
		77621,
		77621
	],
	"./svgs/common/users-up.svg": [
		59663,
		59663
	],
	"./svgs/common/users-x.svg": [
		82769,
		82769
	],
	"./svgs/common/variable.svg": [
		16300,
		16300
	],
	"./svgs/common/video-courses.svg": [
		10115,
		10115
	],
	"./svgs/common/video-recorder-off.svg": [
		42298,
		42298
	],
	"./svgs/common/video-recorder.svg": [
		46854,
		46854
	],
	"./svgs/common/voicemail.svg": [
		13932,
		13932
	],
	"./svgs/common/volume-max.svg": [
		1940,
		1940
	],
	"./svgs/common/volume-min.svg": [
		4380,
		4380
	],
	"./svgs/common/volume-minus.svg": [
		22565,
		22565
	],
	"./svgs/common/volume-plus.svg": [
		87113,
		87113
	],
	"./svgs/common/volume-x.svg": [
		82699,
		82699
	],
	"./svgs/common/wallet-01.svg": [
		62750,
		62750
	],
	"./svgs/common/wallet-02.svg": [
		20822,
		20822
	],
	"./svgs/common/watch-circle.svg": [
		37741,
		37741
	],
	"./svgs/common/waves.svg": [
		10370,
		10370
	],
	"./svgs/common/waving-hand.svg": [
		24601,
		24601
	],
	"./svgs/common/wifi-off.svg": [
		4276,
		4276
	],
	"./svgs/common/wifi.svg": [
		8997,
		8997
	],
	"./svgs/common/wind-01.svg": [
		95680,
		95680
	],
	"./svgs/common/wind-02.svg": [
		21109,
		21109
	],
	"./svgs/common/wind-03.svg": [
		87649,
		87649
	],
	"./svgs/common/x-circle-filled.svg": [
		71157,
		71157
	],
	"./svgs/common/x-circle.svg": [
		65853,
		65853
	],
	"./svgs/common/x-close.svg": [
		7641,
		7641
	],
	"./svgs/common/youtube.svg": [
		22851,
		22851
	],
	"./svgs/common/zap-fast.svg": [
		95169,
		95169
	],
	"./svgs/common/zap-off.svg": [
		35682,
		35682
	],
	"./svgs/common/zap.svg": [
		51072,
		51072
	],
	"./svgs/common/zoom-in.svg": [
		58241,
		58241
	],
	"./svgs/common/zoom-out.svg": [
		61336,
		29246
	],
	"./svgs/country/aed.svg": [
		21289,
		21289
	],
	"./svgs/country/ars.svg": [
		30736,
		30736
	],
	"./svgs/country/aud.svg": [
		20950,
		20950
	],
	"./svgs/country/brl.svg": [
		55804,
		55804
	],
	"./svgs/country/cad.svg": [
		7082,
		7082
	],
	"./svgs/country/clp.svg": [
		83795,
		83795
	],
	"./svgs/country/cop.svg": [
		1695,
		82747
	],
	"./svgs/country/eur.svg": [
		16183,
		16183
	],
	"./svgs/country/gbp.svg": [
		39707,
		39707
	],
	"./svgs/country/huf.svg": [
		1610,
		8936
	],
	"./svgs/country/idr.svg": [
		15870,
		15870
	],
	"./svgs/country/ils.svg": [
		3388,
		3388
	],
	"./svgs/country/inr.svg": [
		29376,
		29376
	],
	"./svgs/country/jpy.svg": [
		59468,
		59468
	],
	"./svgs/country/mxn.svg": [
		20665,
		20665
	],
	"./svgs/country/myr.svg": [
		61114,
		61114
	],
	"./svgs/country/pen.svg": [
		93800,
		93800
	],
	"./svgs/country/php.svg": [
		65148,
		65148
	],
	"./svgs/country/sgd.svg": [
		47652,
		47652
	],
	"./svgs/country/usd.svg": [
		68987,
		68987
	],
	"./svgs/country/uyu.svg": [
		10765,
		10765
	],
	"./svgs/logo/nas-io-logo-coloured.svg": [
		17211,
		17211
	],
	"./svgs/logo/nas-io-logo-grayscale.svg": [
		2543,
		2543
	],
	"./svgs/logo/nas-io-logo-with-text-coloured.svg": [
		55304,
		55304
	],
	"./svgs/logo/nas-io-logo-with-text-grayscale.svg": [
		30310,
		30310
	],
	"./svgs/logo/nas-io-logo-with-text-white.svg": [
		38804,
		38804
	],
	"./svgs/payment-methods/alipay.svg": [
		76034,
		76034
	],
	"./svgs/payment-methods/amazon.svg": [
		15260,
		15260
	],
	"./svgs/payment-methods/amex.svg": [
		4058,
		4058
	],
	"./svgs/payment-methods/applePay.svg": [
		19815,
		19815
	],
	"./svgs/payment-methods/bitPay.svg": [
		33135,
		33135
	],
	"./svgs/payment-methods/cabal.svg": [
		72644,
		72644
	],
	"./svgs/payment-methods/carnet.svg": [
		77758,
		77758
	],
	"./svgs/payment-methods/cmr.svg": [
		92430,
		92430
	],
	"./svgs/payment-methods/credit-card-02.svg": [
		50845,
		68588
	],
	"./svgs/payment-methods/credit-card-filled.svg": [
		48212,
		48212
	],
	"./svgs/payment-methods/diners.svg": [
		50038,
		50038
	],
	"./svgs/payment-methods/ebanx.svg": [
		37224,
		37224
	],
	"./svgs/payment-methods/ebanx_boleto.svg": [
		32234,
		32234
	],
	"./svgs/payment-methods/ebanx_card.svg": [
		68785,
		68785
	],
	"./svgs/payment-methods/ebanx_efecty.svg": [
		6326,
		6326
	],
	"./svgs/payment-methods/ebanx_grayscale.svg": [
		11592,
		11592
	],
	"./svgs/payment-methods/ebanx_mercado.svg": [
		8556,
		8556
	],
	"./svgs/payment-methods/ebanx_nequi.svg": [
		88002,
		88002
	],
	"./svgs/payment-methods/ebanx_nu.svg": [
		28311,
		28311
	],
	"./svgs/payment-methods/ebanx_oxxo.svg": [
		27692,
		27692
	],
	"./svgs/payment-methods/ebanx_pagoefectivo.svg": [
		56041,
		56041
	],
	"./svgs/payment-methods/ebanx_pix.svg": [
		87858,
		87858
	],
	"./svgs/payment-methods/ebanx_safetypay.svg": [
		80897,
		92354
	],
	"./svgs/payment-methods/ebanx_spei.svg": [
		50093,
		50093
	],
	"./svgs/payment-methods/elo.svg": [
		58481,
		58481
	],
	"./svgs/payment-methods/gCash.svg": [
		23521,
		23521
	],
	"./svgs/payment-methods/googlePay.svg": [
		76618,
		76618
	],
	"./svgs/payment-methods/googlePay2.svg": [
		75354,
		75354
	],
	"./svgs/payment-methods/grabPay.svg": [
		87976,
		87976
	],
	"./svgs/payment-methods/hipercard.svg": [
		1381,
		1381
	],
	"./svgs/payment-methods/jcb.svg": [
		68921,
		68921
	],
	"./svgs/payment-methods/maestro.svg": [
		55105,
		55105
	],
	"./svgs/payment-methods/mastercard-black.svg": [
		24029,
		24029
	],
	"./svgs/payment-methods/mastercard.svg": [
		8541,
		8541
	],
	"./svgs/payment-methods/naranja.svg": [
		65229,
		65229
	],
	"./svgs/payment-methods/payMaya.svg": [
		60781,
		60781
	],
	"./svgs/payment-methods/payTm.svg": [
		54552,
		54552
	],
	"./svgs/payment-methods/paypal-greyscale.svg": [
		80020,
		80020
	],
	"./svgs/payment-methods/paypal.svg": [
		30983,
		30983
	],
	"./svgs/payment-methods/paype.svg": [
		77740,
		77740
	],
	"./svgs/payment-methods/pix-full.svg": [
		99547,
		99547
	],
	"./svgs/payment-methods/pix.svg": [
		41523,
		41523
	],
	"./svgs/payment-methods/razorpay-icon-only.svg": [
		30402,
		30402
	],
	"./svgs/payment-methods/razorpay.svg": [
		2279,
		2279
	],
	"./svgs/payment-methods/razorpay_greyscale.svg": [
		81501,
		81501
	],
	"./svgs/payment-methods/shopeePay.svg": [
		5310,
		5310
	],
	"./svgs/payment-methods/sodexo.svg": [
		35195,
		35195
	],
	"./svgs/payment-methods/stripe-grayscale.svg": [
		62266,
		62266
	],
	"./svgs/payment-methods/stripe.svg": [
		710,
		90087
	],
	"./svgs/payment-methods/unionPay.svg": [
		56399,
		56399
	],
	"./svgs/payment-methods/upi-coloured.svg": [
		99474,
		99474
	],
	"./svgs/payment-methods/upi.svg": [
		3757,
		3757
	],
	"./svgs/payment-methods/visa.svg": [
		94414,
		94414
	],
	"./svgs/payment-methods/xendit.svg": [
		12751,
		12751
	],
	"./svgs/social/airbnb-coloured.svg": [
		73097,
		73097
	],
	"./svgs/social/airbnb-neutral.svg": [
		96934,
		96934
	],
	"./svgs/social/apple-neutral.svg": [
		33976,
		33976
	],
	"./svgs/social/coinbase-coloured.svg": [
		39965,
		39965
	],
	"./svgs/social/discord-coloured-circle.svg": [
		7831,
		7831
	],
	"./svgs/social/discord-coloured.svg": [
		32380,
		32380
	],
	"./svgs/social/discord-neutral.svg": [
		12109,
		12109
	],
	"./svgs/social/discord-role-coloured.svg": [
		36438,
		36438
	],
	"./svgs/social/dribbble-coloured.svg": [
		19199,
		19199
	],
	"./svgs/social/dribbble-neutral.svg": [
		4809,
		4809
	],
	"./svgs/social/facebook-coloured.svg": [
		28807,
		28807
	],
	"./svgs/social/facebook-neutral.svg": [
		73295,
		73295
	],
	"./svgs/social/google-calendar.svg": [
		38961,
		38961
	],
	"./svgs/social/google-coloured.svg": [
		55915,
		55915
	],
	"./svgs/social/google-neutral.svg": [
		49168,
		49168
	],
	"./svgs/social/instagram-coloured.svg": [
		24404,
		24404
	],
	"./svgs/social/instagram-neutral.svg": [
		52470,
		52470
	],
	"./svgs/social/line-coloured.svg": [
		24328,
		24328
	],
	"./svgs/social/line-neutral.svg": [
		66993,
		66993
	],
	"./svgs/social/linkedin-coloured.svg": [
		38473,
		38473
	],
	"./svgs/social/linkedin-neutral.svg": [
		1827,
		1827
	],
	"./svgs/social/medium-neutral.svg": [
		26662,
		26662
	],
	"./svgs/social/messenger-neutral.svg": [
		62132,
		62132
	],
	"./svgs/social/metamask-coloured.svg": [
		44056,
		44056
	],
	"./svgs/social/opensea-coloured.svg": [
		49074,
		49074
	],
	"./svgs/social/opensea-neutral.svg": [
		88500,
		88500
	],
	"./svgs/social/patreon-neutral.svg": [
		67005,
		67005
	],
	"./svgs/social/slack-coloured.svg": [
		22721,
		22721
	],
	"./svgs/social/slack-neutral.svg": [
		5897,
		5897
	],
	"./svgs/social/snapchat-neutral.svg": [
		62836,
		62836
	],
	"./svgs/social/solana-coloured.svg": [
		18970,
		18970
	],
	"./svgs/social/spotify-coloured.svg": [
		97179,
		97179
	],
	"./svgs/social/spotify-neutral.svg": [
		35383,
		35383
	],
	"./svgs/social/telegram-coloured.svg": [
		7324,
		7324
	],
	"./svgs/social/telegram-neutral.svg": [
		41269,
		41269
	],
	"./svgs/social/tiktok-coloured.svg": [
		43404,
		43404
	],
	"./svgs/social/tiktok-neutral.svg": [
		55924,
		55924
	],
	"./svgs/social/twitter-coloured.svg": [
		14054,
		14054
	],
	"./svgs/social/twitter-neutral.svg": [
		54469,
		54469
	],
	"./svgs/social/whatsapp-coloured.svg": [
		37580,
		37580
	],
	"./svgs/social/whatsapp-neutral.svg": [
		46798,
		46798
	],
	"./svgs/social/youtube-coloured.svg": [
		51000,
		51000
	],
	"./svgs/social/youtube-neutral.svg": [
		82734,
		82734
	],
	"components/npl/Icon": [
		74679
	],
	"components/npl/Icon/": [
		74679
	],
	"components/npl/Icon/GeneratedIconNames": [
		52923
	],
	"components/npl/Icon/GeneratedIconNames.ts": [
		52923
	],
	"components/npl/Icon/index": [
		74679
	],
	"components/npl/Icon/index.tsx": [
		74679
	],
	"components/npl/Icon/svgs/common/1-1-session.svg": [
		54228,
		54228
	],
	"components/npl/Icon/svgs/common/Pause.svg": [
		39273,
		39273
	],
	"components/npl/Icon/svgs/common/activity-heart.svg": [
		46690,
		46690
	],
	"components/npl/Icon/svgs/common/activity.svg": [
		86490,
		86490
	],
	"components/npl/Icon/svgs/common/affiliate.svg": [
		31717,
		31717
	],
	"components/npl/Icon/svgs/common/airplay.svg": [
		15937,
		15937
	],
	"components/npl/Icon/svgs/common/airpods.svg": [
		87660,
		87660
	],
	"components/npl/Icon/svgs/common/alarm-clock-check.svg": [
		65454,
		25465
	],
	"components/npl/Icon/svgs/common/alarm-clock-minus.svg": [
		42734,
		42734
	],
	"components/npl/Icon/svgs/common/alarm-clock-off.svg": [
		42335,
		42335
	],
	"components/npl/Icon/svgs/common/alarm-clock-plus.svg": [
		60953,
		60953
	],
	"components/npl/Icon/svgs/common/alarm-clock.svg": [
		93074,
		93074
	],
	"components/npl/Icon/svgs/common/alert-circle-filled.svg": [
		62917,
		62917
	],
	"components/npl/Icon/svgs/common/alert-circle.svg": [
		12696,
		12696
	],
	"components/npl/Icon/svgs/common/align-bottom-02.svg": [
		54911,
		54911
	],
	"components/npl/Icon/svgs/common/align-center.svg": [
		39947,
		39947
	],
	"components/npl/Icon/svgs/common/align-horizontal-centre-01.svg": [
		54736,
		65454
	],
	"components/npl/Icon/svgs/common/align-horizontal-centre-02.svg": [
		1618,
		1618
	],
	"components/npl/Icon/svgs/common/align-justify.svg": [
		46461,
		46461
	],
	"components/npl/Icon/svgs/common/align-left-02.svg": [
		80002,
		80002
	],
	"components/npl/Icon/svgs/common/align-left.svg": [
		41673,
		41673
	],
	"components/npl/Icon/svgs/common/align-right-02.svg": [
		48141,
		48141
	],
	"components/npl/Icon/svgs/common/align-right.svg": [
		20181,
		20181
	],
	"components/npl/Icon/svgs/common/align-top-arrow-02.svg": [
		46810,
		46810
	],
	"components/npl/Icon/svgs/common/align-vertical-center-01.svg": [
		87899,
		87899
	],
	"components/npl/Icon/svgs/common/align-vertical-center-02.svg": [
		77144,
		77144
	],
	"components/npl/Icon/svgs/common/anchor.svg": [
		27594,
		27594
	],
	"components/npl/Icon/svgs/common/announcement-03.svg": [
		52278,
		52278
	],
	"components/npl/Icon/svgs/common/archive.svg": [
		95366,
		95366
	],
	"components/npl/Icon/svgs/common/arrow-circle-down-left.svg": [
		25885,
		25885
	],
	"components/npl/Icon/svgs/common/arrow-circle-down-right.svg": [
		33918,
		33918
	],
	"components/npl/Icon/svgs/common/arrow-circle-down.svg": [
		4771,
		4771
	],
	"components/npl/Icon/svgs/common/arrow-circle-left.svg": [
		92766,
		92766
	],
	"components/npl/Icon/svgs/common/arrow-circle-right.svg": [
		6920,
		6920
	],
	"components/npl/Icon/svgs/common/arrow-circle-up-left.svg": [
		35329,
		35329
	],
	"components/npl/Icon/svgs/common/arrow-circle-up-right.svg": [
		96800,
		96800
	],
	"components/npl/Icon/svgs/common/arrow-circle-up.svg": [
		15966,
		15966
	],
	"components/npl/Icon/svgs/common/arrow-down-left.svg": [
		94250,
		94250
	],
	"components/npl/Icon/svgs/common/arrow-down-right.svg": [
		15781,
		15781
	],
	"components/npl/Icon/svgs/common/arrow-down.svg": [
		83432,
		83432
	],
	"components/npl/Icon/svgs/common/arrow-left.svg": [
		12247,
		12247
	],
	"components/npl/Icon/svgs/common/arrow-right.svg": [
		32762,
		32762
	],
	"components/npl/Icon/svgs/common/arrow-up-left.svg": [
		48397,
		48397
	],
	"components/npl/Icon/svgs/common/arrow-up-right.svg": [
		51034,
		51034
	],
	"components/npl/Icon/svgs/common/arrow-up.svg": [
		81766,
		81766
	],
	"components/npl/Icon/svgs/common/ataflow-03.svg": [
		44579,
		44579
	],
	"components/npl/Icon/svgs/common/atom-01.svg": [
		86918,
		86918
	],
	"components/npl/Icon/svgs/common/attachment-01.svg": [
		46779,
		46779
	],
	"components/npl/Icon/svgs/common/award-01.svg": [
		9944,
		9944
	],
	"components/npl/Icon/svgs/common/award-03.svg": [
		75466,
		75466
	],
	"components/npl/Icon/svgs/common/award-04.svg": [
		54725,
		54725
	],
	"components/npl/Icon/svgs/common/award-05.svg": [
		81618,
		81618
	],
	"components/npl/Icon/svgs/common/backpack.svg": [
		23967,
		23967
	],
	"components/npl/Icon/svgs/common/bank-note-01.svg": [
		81961,
		81961
	],
	"components/npl/Icon/svgs/common/bank-note-02.svg": [
		6923,
		6923
	],
	"components/npl/Icon/svgs/common/bank.svg": [
		22698,
		22698
	],
	"components/npl/Icon/svgs/common/bar-chart-01.svg": [
		98079,
		98079
	],
	"components/npl/Icon/svgs/common/bar-chart-02.svg": [
		95561,
		95561
	],
	"components/npl/Icon/svgs/common/bar-chart-03.svg": [
		62601,
		62601
	],
	"components/npl/Icon/svgs/common/bar-chart-circle-01.svg": [
		90097,
		90097
	],
	"components/npl/Icon/svgs/common/bar-chart-circle-02.svg": [
		66256,
		66256
	],
	"components/npl/Icon/svgs/common/bar-chart-circle-03.svg": [
		79813,
		79813
	],
	"components/npl/Icon/svgs/common/bar-chart-square-01.svg": [
		38471,
		38471
	],
	"components/npl/Icon/svgs/common/bar-chart-square-02.svg": [
		53036,
		53036
	],
	"components/npl/Icon/svgs/common/bar-chart-square-03.svg": [
		73298,
		73298
	],
	"components/npl/Icon/svgs/common/bar-chart-square-down.svg": [
		83622,
		83622
	],
	"components/npl/Icon/svgs/common/bar-chart-square-minus.svg": [
		78768,
		78768
	],
	"components/npl/Icon/svgs/common/bar-chart-square-plus.svg": [
		59112,
		59112
	],
	"components/npl/Icon/svgs/common/bar-chart-square-up.svg": [
		4814,
		4814
	],
	"components/npl/Icon/svgs/common/bar-line-chart.svg": [
		68297,
		68297
	],
	"components/npl/Icon/svgs/common/battery-charging-01.svg": [
		51261,
		51261
	],
	"components/npl/Icon/svgs/common/battery-empty.svg": [
		71746,
		71746
	],
	"components/npl/Icon/svgs/common/battery-full.svg": [
		19373,
		19373
	],
	"components/npl/Icon/svgs/common/battery-low.svg": [
		94075,
		61754
	],
	"components/npl/Icon/svgs/common/battery-mid.svg": [
		99821,
		99821
	],
	"components/npl/Icon/svgs/common/beaker-01.svg": [
		50962,
		50962
	],
	"components/npl/Icon/svgs/common/beaker-02.svg": [
		8158,
		8158
	],
	"components/npl/Icon/svgs/common/bell-01.svg": [
		99110,
		99110
	],
	"components/npl/Icon/svgs/common/bell-minus.svg": [
		97661,
		97661
	],
	"components/npl/Icon/svgs/common/bell-off-01.svg": [
		15384,
		15384
	],
	"components/npl/Icon/svgs/common/bell-plus.svg": [
		90087,
		3834
	],
	"components/npl/Icon/svgs/common/bell-ringing-01.svg": [
		97960,
		97960
	],
	"components/npl/Icon/svgs/common/bezier-curve-01.svg": [
		91254,
		91254
	],
	"components/npl/Icon/svgs/common/bezier-curve-02.svg": [
		96895,
		96895
	],
	"components/npl/Icon/svgs/common/bezier-curve-03.svg": [
		56392,
		56392
	],
	"components/npl/Icon/svgs/common/bluetooth-connect.svg": [
		2625,
		2625
	],
	"components/npl/Icon/svgs/common/bluetooth-on.svg": [
		27323,
		27323
	],
	"components/npl/Icon/svgs/common/bluetooth-signal.svg": [
		1321,
		1321
	],
	"components/npl/Icon/svgs/common/bluetooth.svg": [
		4526,
		4526
	],
	"components/npl/Icon/svgs/common/bold-01.svg": [
		81294,
		81294
	],
	"components/npl/Icon/svgs/common/book-closed.svg": [
		67748,
		67748
	],
	"components/npl/Icon/svgs/common/book-open-01.svg": [
		17517,
		17517
	],
	"components/npl/Icon/svgs/common/bookmark-add.svg": [
		71494,
		71494
	],
	"components/npl/Icon/svgs/common/bookmark-check.svg": [
		95431,
		95431
	],
	"components/npl/Icon/svgs/common/bookmark-x.svg": [
		94068,
		94068
	],
	"components/npl/Icon/svgs/common/bookmark.svg": [
		523,
		523
	],
	"components/npl/Icon/svgs/common/box.svg": [
		56245,
		56245
	],
	"components/npl/Icon/svgs/common/brackets-check.svg": [
		42195,
		42195
	],
	"components/npl/Icon/svgs/common/brackets-minus.svg": [
		39020,
		39020
	],
	"components/npl/Icon/svgs/common/brackets-slash.svg": [
		8992,
		8992
	],
	"components/npl/Icon/svgs/common/brackets-x.svg": [
		27900,
		27900
	],
	"components/npl/Icon/svgs/common/brackets.svg": [
		25846,
		25846
	],
	"components/npl/Icon/svgs/common/briefcase-02.svg": [
		65994,
		53979
	],
	"components/npl/Icon/svgs/common/browser.svg": [
		15759,
		15759
	],
	"components/npl/Icon/svgs/common/brush-01.svg": [
		70097,
		70097
	],
	"components/npl/Icon/svgs/common/brush-02.svg": [
		21187,
		21187
	],
	"components/npl/Icon/svgs/common/building-02.svg": [
		4647,
		4647
	],
	"components/npl/Icon/svgs/common/building-03.svg": [
		21266,
		21266
	],
	"components/npl/Icon/svgs/common/building-04.svg": [
		59022,
		59022
	],
	"components/npl/Icon/svgs/common/building-05.svg": [
		95306,
		95306
	],
	"components/npl/Icon/svgs/common/bus.svg": [
		18181,
		18181
	],
	"components/npl/Icon/svgs/common/calculator.svg": [
		36374,
		36374
	],
	"components/npl/Icon/svgs/common/calendar-check-01.svg": [
		87448,
		87448
	],
	"components/npl/Icon/svgs/common/calendar-date.svg": [
		5317,
		5317
	],
	"components/npl/Icon/svgs/common/calendar-heart-01.svg": [
		98017,
		98017
	],
	"components/npl/Icon/svgs/common/calendar-minus-01.svg": [
		91992,
		91992
	],
	"components/npl/Icon/svgs/common/calendar-money.svg": [
		27928,
		27928
	],
	"components/npl/Icon/svgs/common/calendar-plus-01.svg": [
		69695,
		69695
	],
	"components/npl/Icon/svgs/common/calendar-range-01.svg": [
		16331,
		16331
	],
	"components/npl/Icon/svgs/common/calendar.svg": [
		88314,
		88314
	],
	"components/npl/Icon/svgs/common/camera-01.svg": [
		88786,
		88786
	],
	"components/npl/Icon/svgs/common/camera-lens.svg": [
		11585,
		11585
	],
	"components/npl/Icon/svgs/common/camera-off.svg": [
		7317,
		7317
	],
	"components/npl/Icon/svgs/common/camera-plus.svg": [
		82431,
		82431
	],
	"components/npl/Icon/svgs/common/certificate-01.svg": [
		52645,
		52645
	],
	"components/npl/Icon/svgs/common/chart-breakout-circle.svg": [
		83871,
		83871
	],
	"components/npl/Icon/svgs/common/check-circle-filled.svg": [
		83580,
		83580
	],
	"components/npl/Icon/svgs/common/check-circle.svg": [
		95974,
		95974
	],
	"components/npl/Icon/svgs/common/check-heart.svg": [
		28838,
		28838
	],
	"components/npl/Icon/svgs/common/check-square.svg": [
		90191,
		90191
	],
	"components/npl/Icon/svgs/common/check-verified-filled.svg": [
		98422,
		98422
	],
	"components/npl/Icon/svgs/common/check-verified.svg": [
		19060,
		19060
	],
	"components/npl/Icon/svgs/common/check.svg": [
		64554,
		64554
	],
	"components/npl/Icon/svgs/common/chevron-collapse.svg": [
		87611,
		87611
	],
	"components/npl/Icon/svgs/common/chevron-down-circle.svg": [
		89085,
		89085
	],
	"components/npl/Icon/svgs/common/chevron-down.svg": [
		84966,
		84966
	],
	"components/npl/Icon/svgs/common/chevron-left.svg": [
		7458,
		7458
	],
	"components/npl/Icon/svgs/common/chevron-right.svg": [
		75357,
		75357
	],
	"components/npl/Icon/svgs/common/chevron-selector-horizontal.svg": [
		6582,
		6582
	],
	"components/npl/Icon/svgs/common/chevron-selector-vertical.svg": [
		72419,
		72419
	],
	"components/npl/Icon/svgs/common/chevron-up.svg": [
		4614,
		4614
	],
	"components/npl/Icon/svgs/common/chrome-cast.svg": [
		85297,
		85297
	],
	"components/npl/Icon/svgs/common/circle-cut.svg": [
		59870,
		59870
	],
	"components/npl/Icon/svgs/common/clap-fill.svg": [
		15358,
		86640
	],
	"components/npl/Icon/svgs/common/clap.svg": [
		48939,
		48939
	],
	"components/npl/Icon/svgs/common/clipboard-attachment.svg": [
		20506,
		20506
	],
	"components/npl/Icon/svgs/common/clipboard-check.svg": [
		89976,
		89976
	],
	"components/npl/Icon/svgs/common/clipboard-download.svg": [
		14308,
		14308
	],
	"components/npl/Icon/svgs/common/clipboard-minus.svg": [
		36847,
		36847
	],
	"components/npl/Icon/svgs/common/clipboard-plus.svg": [
		13958,
		13958
	],
	"components/npl/Icon/svgs/common/clipboard-x.svg": [
		26326,
		26326
	],
	"components/npl/Icon/svgs/common/clipboard.svg": [
		78188,
		78188
	],
	"components/npl/Icon/svgs/common/clock-check.svg": [
		82346,
		82346
	],
	"components/npl/Icon/svgs/common/clock-fast-forward.svg": [
		79513,
		79513
	],
	"components/npl/Icon/svgs/common/clock-plus.svg": [
		84609,
		84609
	],
	"components/npl/Icon/svgs/common/clock-refresh.svg": [
		76315,
		76315
	],
	"components/npl/Icon/svgs/common/clock-rewind.svg": [
		34179,
		34179
	],
	"components/npl/Icon/svgs/common/clock-snooze.svg": [
		49925,
		49925
	],
	"components/npl/Icon/svgs/common/clock-stopwatch.svg": [
		96996,
		96996
	],
	"components/npl/Icon/svgs/common/clock.svg": [
		88693,
		88693
	],
	"components/npl/Icon/svgs/common/cloud-01.svg": [
		96794,
		96794
	],
	"components/npl/Icon/svgs/common/cloud-02.svg": [
		7540,
		7540
	],
	"components/npl/Icon/svgs/common/cloud-03.svg": [
		35641,
		35641
	],
	"components/npl/Icon/svgs/common/cloud-blank-01.svg": [
		9676,
		9676
	],
	"components/npl/Icon/svgs/common/cloud-lightning.svg": [
		79281,
		79281
	],
	"components/npl/Icon/svgs/common/cloud-moon.svg": [
		45079,
		45079
	],
	"components/npl/Icon/svgs/common/cloud-off.svg": [
		54743,
		54743
	],
	"components/npl/Icon/svgs/common/cloud-raining-01.svg": [
		40565,
		40565
	],
	"components/npl/Icon/svgs/common/cloud-raining-02.svg": [
		61941,
		61941
	],
	"components/npl/Icon/svgs/common/cloud-raining-03.svg": [
		40084,
		40084
	],
	"components/npl/Icon/svgs/common/cloud-raining-04.svg": [
		17524,
		17524
	],
	"components/npl/Icon/svgs/common/cloud-raining-05.svg": [
		45283,
		45283
	],
	"components/npl/Icon/svgs/common/cloud-raining-06.svg": [
		64951,
		64951
	],
	"components/npl/Icon/svgs/common/cloud-snowing-01.svg": [
		61656,
		61656
	],
	"components/npl/Icon/svgs/common/cloud-snowing-02.svg": [
		35802,
		35802
	],
	"components/npl/Icon/svgs/common/cloud-sun-01.svg": [
		65413,
		65413
	],
	"components/npl/Icon/svgs/common/cloud-sun-02.svg": [
		65555,
		65555
	],
	"components/npl/Icon/svgs/common/cloud-sun-03.svg": [
		22955,
		22955
	],
	"components/npl/Icon/svgs/common/code-01.svg": [
		76684,
		76684
	],
	"components/npl/Icon/svgs/common/code-02.svg": [
		55538,
		55538
	],
	"components/npl/Icon/svgs/common/code-browser.svg": [
		68369,
		68369
	],
	"components/npl/Icon/svgs/common/code-circle-01.svg": [
		21776,
		21776
	],
	"components/npl/Icon/svgs/common/code-circle-02.svg": [
		63277,
		63277
	],
	"components/npl/Icon/svgs/common/code-circle-03.svg": [
		41396,
		41396
	],
	"components/npl/Icon/svgs/common/code-square-01.svg": [
		12741,
		12741
	],
	"components/npl/Icon/svgs/common/code-square-02.svg": [
		96438,
		96438
	],
	"components/npl/Icon/svgs/common/codepen.svg": [
		1926,
		1926
	],
	"components/npl/Icon/svgs/common/coins-01.svg": [
		52322,
		52322
	],
	"components/npl/Icon/svgs/common/coins-02.svg": [
		55018,
		55018
	],
	"components/npl/Icon/svgs/common/coins-hand.svg": [
		65460,
		65460
	],
	"components/npl/Icon/svgs/common/coins-stacked-01.svg": [
		82397,
		82397
	],
	"components/npl/Icon/svgs/common/coins-stacked-03.svg": [
		96067,
		96067
	],
	"components/npl/Icon/svgs/common/coins-stacked-04.svg": [
		44282,
		44282
	],
	"components/npl/Icon/svgs/common/coins-swap-02.svg": [
		18051,
		18051
	],
	"components/npl/Icon/svgs/common/colors.svg": [
		34366,
		34366
	],
	"components/npl/Icon/svgs/common/columns-02.svg": [
		97784,
		97784
	],
	"components/npl/Icon/svgs/common/columns-03.svg": [
		79022,
		79022
	],
	"components/npl/Icon/svgs/common/command.svg": [
		36840,
		36840
	],
	"components/npl/Icon/svgs/common/compass-01.svg": [
		60339,
		60339
	],
	"components/npl/Icon/svgs/common/compass.svg": [
		63556,
		63556
	],
	"components/npl/Icon/svgs/common/container.svg": [
		30782,
		30782
	],
	"components/npl/Icon/svgs/common/contrast-01.svg": [
		9685,
		9685
	],
	"components/npl/Icon/svgs/common/contrast-02.svg": [
		32081,
		32081
	],
	"components/npl/Icon/svgs/common/contrast-03.svg": [
		78210,
		78210
	],
	"components/npl/Icon/svgs/common/copy.svg": [
		97959,
		97959
	],
	"components/npl/Icon/svgs/common/cpu-chip-01.svg": [
		64343,
		64343
	],
	"components/npl/Icon/svgs/common/cpu-chip-02.svg": [
		90930,
		90930
	],
	"components/npl/Icon/svgs/common/credit-card-02.svg": [
		42204,
		42204
	],
	"components/npl/Icon/svgs/common/credit-card-check.svg": [
		56405,
		56405
	],
	"components/npl/Icon/svgs/common/credit-card-down.svg": [
		6774,
		6774
	],
	"components/npl/Icon/svgs/common/credit-card-download.svg": [
		88124,
		88124
	],
	"components/npl/Icon/svgs/common/credit-card-edit.svg": [
		21357,
		65994
	],
	"components/npl/Icon/svgs/common/credit-card-lock.svg": [
		40644,
		40644
	],
	"components/npl/Icon/svgs/common/credit-card-minus.svg": [
		26140,
		26140
	],
	"components/npl/Icon/svgs/common/credit-card-plus.svg": [
		49710,
		49710
	],
	"components/npl/Icon/svgs/common/credit-card-refresh.svg": [
		78645,
		78645
	],
	"components/npl/Icon/svgs/common/credit-card-search.svg": [
		27584,
		27584
	],
	"components/npl/Icon/svgs/common/credit-card-shield.svg": [
		88895,
		88895
	],
	"components/npl/Icon/svgs/common/credit-card-up.svg": [
		92302,
		92302
	],
	"components/npl/Icon/svgs/common/credit-card-upload.svg": [
		96325,
		96325
	],
	"components/npl/Icon/svgs/common/credit-card-x.svg": [
		29954,
		29954
	],
	"components/npl/Icon/svgs/common/crop-01.svg": [
		8155,
		8155
	],
	"components/npl/Icon/svgs/common/cryptocurrency-01.svg": [
		56763,
		56763
	],
	"components/npl/Icon/svgs/common/cryptocurrency-02.svg": [
		56864,
		56864
	],
	"components/npl/Icon/svgs/common/cryptocurrency-03.svg": [
		63721,
		63721
	],
	"components/npl/Icon/svgs/common/cryptocurrency-04.svg": [
		37489,
		37489
	],
	"components/npl/Icon/svgs/common/cube-01.svg": [
		67124,
		67124
	],
	"components/npl/Icon/svgs/common/cube-02.svg": [
		55920,
		55920
	],
	"components/npl/Icon/svgs/common/cube-03.svg": [
		60857,
		60857
	],
	"components/npl/Icon/svgs/common/cube-04.svg": [
		50682,
		50682
	],
	"components/npl/Icon/svgs/common/cube-outline.svg": [
		51401,
		51401
	],
	"components/npl/Icon/svgs/common/currency-bitcoin-circle.svg": [
		3844,
		3844
	],
	"components/npl/Icon/svgs/common/currency-bitcoin.svg": [
		84222,
		84222
	],
	"components/npl/Icon/svgs/common/currency-dollar-circle.svg": [
		35970,
		35970
	],
	"components/npl/Icon/svgs/common/currency-dollar.svg": [
		68085,
		68085
	],
	"components/npl/Icon/svgs/common/currency-ethereum-circle.svg": [
		10801,
		10801
	],
	"components/npl/Icon/svgs/common/currency-ethereum.svg": [
		68219,
		68219
	],
	"components/npl/Icon/svgs/common/currency-euro-circle.svg": [
		37695,
		37695
	],
	"components/npl/Icon/svgs/common/currency-euro.svg": [
		84157,
		84157
	],
	"components/npl/Icon/svgs/common/currency-pound-circle.svg": [
		12426,
		12426
	],
	"components/npl/Icon/svgs/common/currency-pound.svg": [
		96688,
		96688
	],
	"components/npl/Icon/svgs/common/currency-ruble-circle.svg": [
		81452,
		81452
	],
	"components/npl/Icon/svgs/common/currency-ruble.svg": [
		56117,
		56117
	],
	"components/npl/Icon/svgs/common/currency-rupee-circle.svg": [
		9304,
		9304
	],
	"components/npl/Icon/svgs/common/currency-rupee.svg": [
		55250,
		55250
	],
	"components/npl/Icon/svgs/common/currency-yen-circle.svg": [
		33767,
		33767
	],
	"components/npl/Icon/svgs/common/currency-yen.svg": [
		19536,
		19536
	],
	"components/npl/Icon/svgs/common/cursor-01.svg": [
		70274,
		70274
	],
	"components/npl/Icon/svgs/common/cursor-02.svg": [
		29779,
		29779
	],
	"components/npl/Icon/svgs/common/cursor-04.svg": [
		43941,
		43941
	],
	"components/npl/Icon/svgs/common/cursor-box.svg": [
		24644,
		24644
	],
	"components/npl/Icon/svgs/common/cursor-click-01.svg": [
		96341,
		96341
	],
	"components/npl/Icon/svgs/common/cursor-click-02.svg": [
		80301,
		80301
	],
	"components/npl/Icon/svgs/common/data.svg": [
		22209,
		22209
	],
	"components/npl/Icon/svgs/common/database-02.svg": [
		69053,
		51879
	],
	"components/npl/Icon/svgs/common/database-03.svg": [
		69607,
		69607
	],
	"components/npl/Icon/svgs/common/dataflow-01.svg": [
		88211,
		88211
	],
	"components/npl/Icon/svgs/common/dataflow-02.svg": [
		12449,
		12449
	],
	"components/npl/Icon/svgs/common/dataflow-04.svg": [
		93683,
		93683
	],
	"components/npl/Icon/svgs/common/delete.svg": [
		44503,
		44503
	],
	"components/npl/Icon/svgs/common/diamond-01.svg": [
		16993,
		16993
	],
	"components/npl/Icon/svgs/common/dice-1.svg": [
		35598,
		35598
	],
	"components/npl/Icon/svgs/common/dice-2.svg": [
		22289,
		22289
	],
	"components/npl/Icon/svgs/common/dice-3.svg": [
		14819,
		14819
	],
	"components/npl/Icon/svgs/common/dice-4.svg": [
		21886,
		21886
	],
	"components/npl/Icon/svgs/common/dice-5.svg": [
		5805,
		5805
	],
	"components/npl/Icon/svgs/common/dice-6.svg": [
		91668,
		91668
	],
	"components/npl/Icon/svgs/common/disc-02.svg": [
		32086,
		32086
	],
	"components/npl/Icon/svgs/common/distribute-spacing-horizontal.svg": [
		77025,
		77025
	],
	"components/npl/Icon/svgs/common/distribute-spacing-vertical-filled.svg": [
		63922,
		63922
	],
	"components/npl/Icon/svgs/common/distribute-spacing-vertical.svg": [
		31891,
		31891
	],
	"components/npl/Icon/svgs/common/divide-01.svg": [
		88649,
		88649
	],
	"components/npl/Icon/svgs/common/divider.svg": [
		18586,
		18586
	],
	"components/npl/Icon/svgs/common/dotpoints-01.svg": [
		10687,
		10687
	],
	"components/npl/Icon/svgs/common/dots-horizontal.svg": [
		33954,
		33954
	],
	"components/npl/Icon/svgs/common/dots-reorder-drag.svg": [
		81607,
		81607
	],
	"components/npl/Icon/svgs/common/dots-vertical.svg": [
		18477,
		18477
	],
	"components/npl/Icon/svgs/common/download-01.svg": [
		77024,
		77024
	],
	"components/npl/Icon/svgs/common/download-02.svg": [
		40480,
		40480
	],
	"components/npl/Icon/svgs/common/download-cloud-01.svg": [
		70908,
		70908
	],
	"components/npl/Icon/svgs/common/drop.svg": [
		91420,
		91420
	],
	"components/npl/Icon/svgs/common/droplets-01.svg": [
		70092,
		70092
	],
	"components/npl/Icon/svgs/common/droplets-02.svg": [
		5137,
		5137
	],
	"components/npl/Icon/svgs/common/droplets-03.svg": [
		66596,
		66596
	],
	"components/npl/Icon/svgs/common/dropper.svg": [
		61953,
		61953
	],
	"components/npl/Icon/svgs/common/duplicate.svg": [
		88331,
		88331
	],
	"components/npl/Icon/svgs/common/edit-04.svg": [
		19131,
		19131
	],
	"components/npl/Icon/svgs/common/edit.svg": [
		34688,
		34688
	],
	"components/npl/Icon/svgs/common/eraser.svg": [
		85875,
		85875
	],
	"components/npl/Icon/svgs/common/expand-01.svg": [
		31683,
		31683
	],
	"components/npl/Icon/svgs/common/expand-width.svg": [
		75072,
		75072
	],
	"components/npl/Icon/svgs/common/eye-first.svg": [
		20182,
		20182
	],
	"components/npl/Icon/svgs/common/eye-off.svg": [
		22027,
		22027
	],
	"components/npl/Icon/svgs/common/eye-second.svg": [
		19324,
		19324
	],
	"components/npl/Icon/svgs/common/eye.svg": [
		86154,
		86154
	],
	"components/npl/Icon/svgs/common/face-frown.svg": [
		99040,
		99040
	],
	"components/npl/Icon/svgs/common/face-happy.svg": [
		95140,
		95140
	],
	"components/npl/Icon/svgs/common/face-id.svg": [
		137,
		137
	],
	"components/npl/Icon/svgs/common/face-neutral.svg": [
		55784,
		55784
	],
	"components/npl/Icon/svgs/common/face-smile.svg": [
		97603,
		97603
	],
	"components/npl/Icon/svgs/common/face-wink.svg": [
		11703,
		11703
	],
	"components/npl/Icon/svgs/common/fast-backward.svg": [
		32106,
		32106
	],
	"components/npl/Icon/svgs/common/fast-forward.svg": [
		59146,
		59146
	],
	"components/npl/Icon/svgs/common/feather.svg": [
		47949,
		47949
	],
	"components/npl/Icon/svgs/common/figma.svg": [
		27027,
		27027
	],
	"components/npl/Icon/svgs/common/file-01.svg": [
		51672,
		51672
	],
	"components/npl/Icon/svgs/common/file-02.svg": [
		7787,
		7787
	],
	"components/npl/Icon/svgs/common/file-03.svg": [
		82013,
		98455
	],
	"components/npl/Icon/svgs/common/file-attachment-04.svg": [
		2511,
		2511
	],
	"components/npl/Icon/svgs/common/file-check-01.svg": [
		24441,
		24441
	],
	"components/npl/Icon/svgs/common/file-code-01.svg": [
		84680,
		84680
	],
	"components/npl/Icon/svgs/common/file-code-02.svg": [
		47225,
		47225
	],
	"components/npl/Icon/svgs/common/file-download-01.svg": [
		20551,
		20551
	],
	"components/npl/Icon/svgs/common/file-heart-01.svg": [
		49016,
		49016
	],
	"components/npl/Icon/svgs/common/file-lock-03.svg": [
		39570,
		39570
	],
	"components/npl/Icon/svgs/common/file-minus-01.svg": [
		7070,
		7070
	],
	"components/npl/Icon/svgs/common/file-plus-01.svg": [
		31629,
		31629
	],
	"components/npl/Icon/svgs/common/file-question-01.svg": [
		31369,
		31369
	],
	"components/npl/Icon/svgs/common/file-search-01.svg": [
		31901,
		31901
	],
	"components/npl/Icon/svgs/common/file-shield-03.svg": [
		28354,
		28354
	],
	"components/npl/Icon/svgs/common/file-x-01.svg": [
		88257,
		88257
	],
	"components/npl/Icon/svgs/common/film-01.svg": [
		90501,
		90501
	],
	"components/npl/Icon/svgs/common/film-02.svg": [
		63979,
		63979
	],
	"components/npl/Icon/svgs/common/filter-funnel-01.svg": [
		97449,
		97449
	],
	"components/npl/Icon/svgs/common/filter-lines.svg": [
		48731,
		48731
	],
	"components/npl/Icon/svgs/common/fingerprint-03.svg": [
		17257,
		17257
	],
	"components/npl/Icon/svgs/common/flag-01.svg": [
		20072,
		11285
	],
	"components/npl/Icon/svgs/common/flag-02.svg": [
		41869,
		6525
	],
	"components/npl/Icon/svgs/common/flash-off.svg": [
		39068,
		39068
	],
	"components/npl/Icon/svgs/common/flash.svg": [
		8165,
		8165
	],
	"components/npl/Icon/svgs/common/flex-align-bottom.svg": [
		66471,
		66471
	],
	"components/npl/Icon/svgs/common/flex-align-left.svg": [
		10509,
		10509
	],
	"components/npl/Icon/svgs/common/flex-align-right.svg": [
		20809,
		20809
	],
	"components/npl/Icon/svgs/common/flex-align-top.svg": [
		66361,
		66361
	],
	"components/npl/Icon/svgs/common/flip-backward.svg": [
		98624,
		98624
	],
	"components/npl/Icon/svgs/common/flip-forward.svg": [
		65063,
		52333
	],
	"components/npl/Icon/svgs/common/folder-check.svg": [
		54885,
		54885
	],
	"components/npl/Icon/svgs/common/folder-closed.svg": [
		77547,
		77547
	],
	"components/npl/Icon/svgs/common/folder-code.svg": [
		30005,
		30005
	],
	"components/npl/Icon/svgs/common/folder-download.svg": [
		45144,
		45144
	],
	"components/npl/Icon/svgs/common/folder-lock.svg": [
		4365,
		4365
	],
	"components/npl/Icon/svgs/common/folder-minus.svg": [
		7588,
		7588
	],
	"components/npl/Icon/svgs/common/folder-plus.svg": [
		61488,
		61488
	],
	"components/npl/Icon/svgs/common/folder-question.svg": [
		92506,
		92506
	],
	"components/npl/Icon/svgs/common/folder-search.svg": [
		90161,
		90161
	],
	"components/npl/Icon/svgs/common/folder-shield.svg": [
		64334,
		64334
	],
	"components/npl/Icon/svgs/common/folder-x.svg": [
		70607,
		70607
	],
	"components/npl/Icon/svgs/common/folder.svg": [
		64787,
		64787
	],
	"components/npl/Icon/svgs/common/framer.svg": [
		79290,
		79290
	],
	"components/npl/Icon/svgs/common/gaming-pad-01.svg": [
		90485,
		90485
	],
	"components/npl/Icon/svgs/common/gift-01.svg": [
		46812,
		46812
	],
	"components/npl/Icon/svgs/common/git-branch-01.svg": [
		29953,
		29953
	],
	"components/npl/Icon/svgs/common/git-branch-02.svg": [
		64031,
		64031
	],
	"components/npl/Icon/svgs/common/git-commit.svg": [
		75009,
		75009
	],
	"components/npl/Icon/svgs/common/git-merge.svg": [
		85703,
		85703
	],
	"components/npl/Icon/svgs/common/git-pull-request.svg": [
		54566,
		54566
	],
	"components/npl/Icon/svgs/common/glasses-01.svg": [
		64919,
		64919
	],
	"components/npl/Icon/svgs/common/glasses-02.svg": [
		10978,
		10978
	],
	"components/npl/Icon/svgs/common/globe-02.svg": [
		92507,
		92507
	],
	"components/npl/Icon/svgs/common/globe-04.svg": [
		45387,
		45387
	],
	"components/npl/Icon/svgs/common/globe-05.svg": [
		34237,
		34237
	],
	"components/npl/Icon/svgs/common/globe-06.svg": [
		33495,
		33495
	],
	"components/npl/Icon/svgs/common/globe-search-02.svg": [
		88328,
		88328
	],
	"components/npl/Icon/svgs/common/graduation-hat-01.svg": [
		79560,
		79560
	],
	"components/npl/Icon/svgs/common/graduation-hat-02.svg": [
		19456,
		19456
	],
	"components/npl/Icon/svgs/common/grid-01.svg": [
		14794,
		14794
	],
	"components/npl/Icon/svgs/common/grid-02.svg": [
		16811,
		16811
	],
	"components/npl/Icon/svgs/common/grid-03.svg": [
		41293,
		41293
	],
	"components/npl/Icon/svgs/common/grid.svg": [
		37261,
		37261
	],
	"components/npl/Icon/svgs/common/h1.svg": [
		57082,
		57082
	],
	"components/npl/Icon/svgs/common/h2.svg": [
		9555,
		9555
	],
	"components/npl/Icon/svgs/common/h3.svg": [
		35953,
		35953
	],
	"components/npl/Icon/svgs/common/hand.svg": [
		33108,
		33108
	],
	"components/npl/Icon/svgs/common/hard-drive.svg": [
		38385,
		38385
	],
	"components/npl/Icon/svgs/common/hash-01.svg": [
		32824,
		32824
	],
	"components/npl/Icon/svgs/common/hash-02.svg": [
		97684,
		97684
	],
	"components/npl/Icon/svgs/common/heading-01.svg": [
		18276,
		18276
	],
	"components/npl/Icon/svgs/common/headphones-01.svg": [
		82230,
		82230
	],
	"components/npl/Icon/svgs/common/headphones-02.svg": [
		80637,
		80637
	],
	"components/npl/Icon/svgs/common/heart-circle.svg": [
		57134,
		57134
	],
	"components/npl/Icon/svgs/common/heart-filled.svg": [
		68366,
		68366
	],
	"components/npl/Icon/svgs/common/heart-hand.svg": [
		88251,
		88251
	],
	"components/npl/Icon/svgs/common/heart-hide.svg": [
		59529,
		59529
	],
	"components/npl/Icon/svgs/common/heart.svg": [
		82331,
		82331
	],
	"components/npl/Icon/svgs/common/help-circle.svg": [
		62254,
		62254
	],
	"components/npl/Icon/svgs/common/hexagon-01.svg": [
		38113,
		38113
	],
	"components/npl/Icon/svgs/common/hexagon-02.svg": [
		3946,
		3946
	],
	"components/npl/Icon/svgs/common/hield-03.svg": [
		15125,
		15125
	],
	"components/npl/Icon/svgs/common/home-smile.svg": [
		54949,
		54949
	],
	"components/npl/Icon/svgs/common/home.svg": [
		35759,
		35759
	],
	"components/npl/Icon/svgs/common/hone-01.svg": [
		53051,
		53051
	],
	"components/npl/Icon/svgs/common/hourglass-01.svg": [
		82888,
		82888
	],
	"components/npl/Icon/svgs/common/hourglass-03.svg": [
		74520,
		74520
	],
	"components/npl/Icon/svgs/common/hurricane-01.svg": [
		74554,
		74554
	],
	"components/npl/Icon/svgs/common/hurricane-02.svg": [
		40359,
		40359
	],
	"components/npl/Icon/svgs/common/hurricane-03.svg": [
		79275,
		79275
	],
	"components/npl/Icon/svgs/common/image-01.svg": [
		76752,
		76752
	],
	"components/npl/Icon/svgs/common/image-check.svg": [
		40917,
		40917
	],
	"components/npl/Icon/svgs/common/image-down.svg": [
		71733,
		71733
	],
	"components/npl/Icon/svgs/common/image-indent-left.svg": [
		72000,
		72000
	],
	"components/npl/Icon/svgs/common/image-indent-right.svg": [
		68118,
		68118
	],
	"components/npl/Icon/svgs/common/image-left.svg": [
		63354,
		63354
	],
	"components/npl/Icon/svgs/common/image-plus.svg": [
		4542,
		4542
	],
	"components/npl/Icon/svgs/common/image-right.svg": [
		83575,
		83575
	],
	"components/npl/Icon/svgs/common/image-up.svg": [
		86083,
		86083
	],
	"components/npl/Icon/svgs/common/image-user-check.svg": [
		824,
		824
	],
	"components/npl/Icon/svgs/common/image-user-down.svg": [
		40843,
		40843
	],
	"components/npl/Icon/svgs/common/image-user-left.svg": [
		82064,
		82064
	],
	"components/npl/Icon/svgs/common/image-user-plus.svg": [
		15315,
		15315
	],
	"components/npl/Icon/svgs/common/image-user-right.svg": [
		73875,
		73875
	],
	"components/npl/Icon/svgs/common/image-user-up.svg": [
		64461,
		64461
	],
	"components/npl/Icon/svgs/common/image-user-x.svg": [
		47884,
		47884
	],
	"components/npl/Icon/svgs/common/image-user.svg": [
		5906,
		5906
	],
	"components/npl/Icon/svgs/common/image-x.svg": [
		57976,
		57976
	],
	"components/npl/Icon/svgs/common/inbox-01.svg": [
		69563,
		69563
	],
	"components/npl/Icon/svgs/common/infinity.svg": [
		33962,
		33962
	],
	"components/npl/Icon/svgs/common/info-circle-filled.svg": [
		23439,
		23439
	],
	"components/npl/Icon/svgs/common/info-circle.svg": [
		28187,
		28187
	],
	"components/npl/Icon/svgs/common/intersect-circle.svg": [
		10229,
		10229
	],
	"components/npl/Icon/svgs/common/intersect-square.svg": [
		64602,
		64602
	],
	"components/npl/Icon/svgs/common/italic-01.svg": [
		49112,
		49112
	],
	"components/npl/Icon/svgs/common/key-01.svg": [
		48502,
		48502
	],
	"components/npl/Icon/svgs/common/keyboard-02.svg": [
		80050,
		80050
	],
	"components/npl/Icon/svgs/common/keyboard-dismiss.svg": [
		80732,
		80732
	],
	"components/npl/Icon/svgs/common/keyboard-show.svg": [
		1297,
		1297
	],
	"components/npl/Icon/svgs/common/laptop-02.svg": [
		82048,
		82048
	],
	"components/npl/Icon/svgs/common/layer-single.svg": [
		55566,
		55566
	],
	"components/npl/Icon/svgs/common/layers-three-01.svg": [
		70730,
		70730
	],
	"components/npl/Icon/svgs/common/layers-three-02.svg": [
		67048,
		67048
	],
	"components/npl/Icon/svgs/common/layers-two-01.svg": [
		15124,
		15124
	],
	"components/npl/Icon/svgs/common/layers-two-02.svg": [
		9518,
		9518
	],
	"components/npl/Icon/svgs/common/layout-alt-01.svg": [
		50194,
		50194
	],
	"components/npl/Icon/svgs/common/layout-alt-02.svg": [
		43736,
		43736
	],
	"components/npl/Icon/svgs/common/layout-alt-03.svg": [
		33567,
		14569
	],
	"components/npl/Icon/svgs/common/layout-alt-04.svg": [
		23061,
		23061
	],
	"components/npl/Icon/svgs/common/layout-bottom.svg": [
		56454,
		56454
	],
	"components/npl/Icon/svgs/common/layout-grid-01.svg": [
		17657,
		17657
	],
	"components/npl/Icon/svgs/common/layout-grid-02.svg": [
		70537,
		70537
	],
	"components/npl/Icon/svgs/common/layout-left.svg": [
		94487,
		94487
	],
	"components/npl/Icon/svgs/common/layout-right-filled.svg": [
		33114,
		33114
	],
	"components/npl/Icon/svgs/common/layout-right.svg": [
		66701,
		66701
	],
	"components/npl/Icon/svgs/common/layout-top.svg": [
		93532,
		93532
	],
	"components/npl/Icon/svgs/common/left-indent-01.svg": [
		20960,
		20960
	],
	"components/npl/Icon/svgs/common/left-indent-02.svg": [
		95651,
		95651
	],
	"components/npl/Icon/svgs/common/letter-spacing-01.svg": [
		70285,
		70285
	],
	"components/npl/Icon/svgs/common/letter-spacing-02.svg": [
		99418,
		99418
	],
	"components/npl/Icon/svgs/common/lightbulb-01.svg": [
		11625,
		11625
	],
	"components/npl/Icon/svgs/common/lightbulb-02.svg": [
		57296,
		57296
	],
	"components/npl/Icon/svgs/common/lightning-01.svg": [
		12240,
		12240
	],
	"components/npl/Icon/svgs/common/lightning-02.svg": [
		53684,
		53684
	],
	"components/npl/Icon/svgs/common/lightning-filled-01.svg": [
		12310,
		12310
	],
	"components/npl/Icon/svgs/common/line-chart-down-02.svg": [
		14813,
		14813
	],
	"components/npl/Icon/svgs/common/line-chart-down-03.svg": [
		64408,
		64408
	],
	"components/npl/Icon/svgs/common/line-chart-up-02.svg": [
		25523,
		25523
	],
	"components/npl/Icon/svgs/common/line-chart-up-03.svg": [
		2985,
		2985
	],
	"components/npl/Icon/svgs/common/line-height.svg": [
		31277,
		31277
	],
	"components/npl/Icon/svgs/common/link-01.svg": [
		25170,
		25170
	],
	"components/npl/Icon/svgs/common/link-broken-02.svg": [
		60544,
		60544
	],
	"components/npl/Icon/svgs/common/link-external-01.svg": [
		58250,
		58250
	],
	"components/npl/Icon/svgs/common/loading-01.svg": [
		34777,
		34777
	],
	"components/npl/Icon/svgs/common/loading-02.svg": [
		37066,
		37066
	],
	"components/npl/Icon/svgs/common/lock-01.svg": [
		4546,
		4546
	],
	"components/npl/Icon/svgs/common/lock-03.svg": [
		22652,
		22652
	],
	"components/npl/Icon/svgs/common/lock-keyhole-circle.svg": [
		51486,
		51486
	],
	"components/npl/Icon/svgs/common/lock-keyhole-square.svg": [
		62578,
		62578
	],
	"components/npl/Icon/svgs/common/lock-unlocked-01.svg": [
		92837,
		92837
	],
	"components/npl/Icon/svgs/common/log-in.svg": [
		68124,
		68124
	],
	"components/npl/Icon/svgs/common/log-out.svg": [
		39608,
		39608
	],
	"components/npl/Icon/svgs/common/luggage-01.svg": [
		90796,
		90796
	],
	"components/npl/Icon/svgs/common/luggage-03.svg": [
		12019,
		12019
	],
	"components/npl/Icon/svgs/common/magic-wand-01.svg": [
		1849,
		1849
	],
	"components/npl/Icon/svgs/common/magic-wand-02.svg": [
		10544,
		10544
	],
	"components/npl/Icon/svgs/common/mail-01.svg": [
		67146,
		67146
	],
	"components/npl/Icon/svgs/common/mail-04.svg": [
		30705,
		30705
	],
	"components/npl/Icon/svgs/common/map-01.svg": [
		69329,
		69329
	],
	"components/npl/Icon/svgs/common/mark.svg": [
		38155,
		38155
	],
	"components/npl/Icon/svgs/common/marker-pin-01.svg": [
		93923,
		93923
	],
	"components/npl/Icon/svgs/common/marker-pin-04.svg": [
		35733,
		35733
	],
	"components/npl/Icon/svgs/common/marker-pin-05.svg": [
		92629,
		92629
	],
	"components/npl/Icon/svgs/common/marker-pin-06.svg": [
		15876,
		15876
	],
	"components/npl/Icon/svgs/common/maximize-01.svg": [
		37280,
		37280
	],
	"components/npl/Icon/svgs/common/maximize-02.svg": [
		31242,
		31242
	],
	"components/npl/Icon/svgs/common/medical-circle.svg": [
		53883,
		53883
	],
	"components/npl/Icon/svgs/common/medical-cross.svg": [
		50515,
		50515
	],
	"components/npl/Icon/svgs/common/menu-01.svg": [
		26117,
		26117
	],
	"components/npl/Icon/svgs/common/menu-02.svg": [
		36135,
		36135
	],
	"components/npl/Icon/svgs/common/menu-close-01.svg": [
		59074,
		59074
	],
	"components/npl/Icon/svgs/common/message-alert-square.svg": [
		19494,
		19494
	],
	"components/npl/Icon/svgs/common/message-chat-circle.svg": [
		76178,
		76178
	],
	"components/npl/Icon/svgs/common/message-chat-square.svg": [
		79100,
		79100
	],
	"components/npl/Icon/svgs/common/message-check-square.svg": [
		90681,
		90681
	],
	"components/npl/Icon/svgs/common/message-circle-02.svg": [
		60976,
		60976
	],
	"components/npl/Icon/svgs/common/message-dots-square.svg": [
		11395,
		11395
	],
	"components/npl/Icon/svgs/common/message-heart-square.svg": [
		37146,
		37146
	],
	"components/npl/Icon/svgs/common/message-notification-square.svg": [
		48316,
		48316
	],
	"components/npl/Icon/svgs/common/message-plus-square.svg": [
		73017,
		73017
	],
	"components/npl/Icon/svgs/common/message-question-square.svg": [
		84261,
		84261
	],
	"components/npl/Icon/svgs/common/message-smile-square.svg": [
		47417,
		47417
	],
	"components/npl/Icon/svgs/common/message-square-02.svg": [
		38904,
		38904
	],
	"components/npl/Icon/svgs/common/message-square-filled-02.svg": [
		59872,
		59872
	],
	"components/npl/Icon/svgs/common/message-text-square-02.svg": [
		27781,
		27781
	],
	"components/npl/Icon/svgs/common/message-x-square.svg": [
		98372,
		98372
	],
	"components/npl/Icon/svgs/common/microphone-01.svg": [
		54603,
		54603
	],
	"components/npl/Icon/svgs/common/microphone-off-01.svg": [
		82584,
		82584
	],
	"components/npl/Icon/svgs/common/microscope.svg": [
		15819,
		15819
	],
	"components/npl/Icon/svgs/common/minimize-01.svg": [
		13114,
		13114
	],
	"components/npl/Icon/svgs/common/minimize-02.svg": [
		56711,
		56711
	],
	"components/npl/Icon/svgs/common/minus-circle.svg": [
		47503,
		47503
	],
	"components/npl/Icon/svgs/common/minus.svg": [
		5429,
		5429
	],
	"components/npl/Icon/svgs/common/monitor-01.svg": [
		57713,
		57713
	],
	"components/npl/Icon/svgs/common/monitor-03.svg": [
		40344,
		40344
	],
	"components/npl/Icon/svgs/common/monitor-05.svg": [
		25912,
		25912
	],
	"components/npl/Icon/svgs/common/moon-01.svg": [
		78660,
		78660
	],
	"components/npl/Icon/svgs/common/moon-02.svg": [
		42043,
		42043
	],
	"components/npl/Icon/svgs/common/moon-eclipse.svg": [
		9800,
		9800
	],
	"components/npl/Icon/svgs/common/moon-star.svg": [
		20929,
		20929
	],
	"components/npl/Icon/svgs/common/mouse.svg": [
		44883,
		44883
	],
	"components/npl/Icon/svgs/common/move.svg": [
		21379,
		21379
	],
	"components/npl/Icon/svgs/common/music-note-01.svg": [
		60699,
		60699
	],
	"components/npl/Icon/svgs/common/music-note-02.svg": [
		40640,
		40640
	],
	"components/npl/Icon/svgs/common/music.svg": [
		68867,
		68867
	],
	"components/npl/Icon/svgs/common/navigation-pointer-01.svg": [
		43072,
		43072
	],
	"components/npl/Icon/svgs/common/navigation-pointer-02.svg": [
		62005,
		62801
	],
	"components/npl/Icon/svgs/common/navigation-pointer-off-01.svg": [
		89238,
		89238
	],
	"components/npl/Icon/svgs/common/navigation-pointer-off-02.svg": [
		56176,
		56176
	],
	"components/npl/Icon/svgs/common/notification-box.svg": [
		66581,
		66581
	],
	"components/npl/Icon/svgs/common/notification-text.svg": [
		92197,
		9412
	],
	"components/npl/Icon/svgs/common/number-list.svg": [
		39537,
		39537
	],
	"components/npl/Icon/svgs/common/octagon.svg": [
		7569,
		7569
	],
	"components/npl/Icon/svgs/common/package-check.svg": [
		9132,
		9132
	],
	"components/npl/Icon/svgs/common/package-minus.svg": [
		65909,
		65909
	],
	"components/npl/Icon/svgs/common/package-plus.svg": [
		46267,
		46267
	],
	"components/npl/Icon/svgs/common/package-search.svg": [
		24525,
		24525
	],
	"components/npl/Icon/svgs/common/package-x.svg": [
		80104,
		80104
	],
	"components/npl/Icon/svgs/common/package.svg": [
		63269,
		63269
	],
	"components/npl/Icon/svgs/common/paint-pour.svg": [
		98633,
		98633
	],
	"components/npl/Icon/svgs/common/paint.svg": [
		20752,
		20752
	],
	"components/npl/Icon/svgs/common/palette.svg": [
		99443,
		99443
	],
	"components/npl/Icon/svgs/common/paperclip.svg": [
		31625,
		31625
	],
	"components/npl/Icon/svgs/common/paragraph-spacing.svg": [
		47310,
		47310
	],
	"components/npl/Icon/svgs/common/paragraph-wrap.svg": [
		83933,
		83933
	],
	"components/npl/Icon/svgs/common/passcode-lock.svg": [
		27784,
		27784
	],
	"components/npl/Icon/svgs/common/passcode.svg": [
		85939,
		85939
	],
	"components/npl/Icon/svgs/common/passport.svg": [
		29981,
		29981
	],
	"components/npl/Icon/svgs/common/pause-circle.svg": [
		94621,
		94621
	],
	"components/npl/Icon/svgs/common/pause-square.svg": [
		65675,
		65675
	],
	"components/npl/Icon/svgs/common/payment-upi.svg": [
		30543,
		30543
	],
	"components/npl/Icon/svgs/common/pen-tool-02.svg": [
		27270,
		27270
	],
	"components/npl/Icon/svgs/common/pen-tool-minus.svg": [
		39049,
		39049
	],
	"components/npl/Icon/svgs/common/pen-tool-plus.svg": [
		76521,
		76521
	],
	"components/npl/Icon/svgs/common/pencil-01.svg": [
		13950,
		13950
	],
	"components/npl/Icon/svgs/common/pencil-line.svg": [
		25850,
		25850
	],
	"components/npl/Icon/svgs/common/pentagon.svg": [
		11308,
		11308
	],
	"components/npl/Icon/svgs/common/percent-01.svg": [
		35987,
		35987
	],
	"components/npl/Icon/svgs/common/percent-03.svg": [
		64032,
		64032
	],
	"components/npl/Icon/svgs/common/perspective-01.svg": [
		20386,
		20386
	],
	"components/npl/Icon/svgs/common/perspective-02.svg": [
		74139,
		74139
	],
	"components/npl/Icon/svgs/common/phone-call-01.svg": [
		47088,
		47088
	],
	"components/npl/Icon/svgs/common/phone-hang-up.svg": [
		44248,
		44248
	],
	"components/npl/Icon/svgs/common/phone-incoming-02.svg": [
		23917,
		23917
	],
	"components/npl/Icon/svgs/common/phone-outgoing-02.svg": [
		75958,
		75958
	],
	"components/npl/Icon/svgs/common/phone-plus.svg": [
		95097,
		95097
	],
	"components/npl/Icon/svgs/common/phone-x.svg": [
		71378,
		71378
	],
	"components/npl/Icon/svgs/common/phone.svg": [
		98090,
		98090
	],
	"components/npl/Icon/svgs/common/pie-chart-01.svg": [
		72344,
		72344
	],
	"components/npl/Icon/svgs/common/pie-chart-02.svg": [
		36792,
		36792
	],
	"components/npl/Icon/svgs/common/pie-chart-03.svg": [
		86445,
		86445
	],
	"components/npl/Icon/svgs/common/piggy-bank-01.svg": [
		10179,
		10179
	],
	"components/npl/Icon/svgs/common/pilcrow-01.svg": [
		34114,
		34114
	],
	"components/npl/Icon/svgs/common/pin-filled.svg": [
		34335,
		34335
	],
	"components/npl/Icon/svgs/common/pin.svg": [
		23585,
		23585
	],
	"components/npl/Icon/svgs/common/placeholder.svg": [
		70246,
		70246
	],
	"components/npl/Icon/svgs/common/plane.svg": [
		53890,
		53890
	],
	"components/npl/Icon/svgs/common/play-circle.svg": [
		13591,
		13591
	],
	"components/npl/Icon/svgs/common/play-filled.svg": [
		14217,
		14217
	],
	"components/npl/Icon/svgs/common/play-square.svg": [
		32270,
		32270
	],
	"components/npl/Icon/svgs/common/play.svg": [
		49066,
		49066
	],
	"components/npl/Icon/svgs/common/plus-circle.svg": [
		78075,
		78075
	],
	"components/npl/Icon/svgs/common/plus.svg": [
		16362,
		16362
	],
	"components/npl/Icon/svgs/common/podcast.svg": [
		75471,
		75471
	],
	"components/npl/Icon/svgs/common/podium.svg": [
		64281,
		64281
	],
	"components/npl/Icon/svgs/common/power-01.svg": [
		29791,
		29791
	],
	"components/npl/Icon/svgs/common/power-02.svg": [
		51956,
		51956
	],
	"components/npl/Icon/svgs/common/presentation-chart-01.svg": [
		34489,
		34489
	],
	"components/npl/Icon/svgs/common/printer.svg": [
		60515,
		60515
	],
	"components/npl/Icon/svgs/common/public-page.svg": [
		660,
		660
	],
	"components/npl/Icon/svgs/common/puzzle-piece-02.svg": [
		87150,
		87150
	],
	"components/npl/Icon/svgs/common/puzzle-piece.svg": [
		43063,
		43063
	],
	"components/npl/Icon/svgs/common/qr-code-02.svg": [
		6687,
		6687
	],
	"components/npl/Icon/svgs/common/rackets-ellipses.svg": [
		72711,
		72711
	],
	"components/npl/Icon/svgs/common/rackets-plus.svg": [
		25769,
		25769
	],
	"components/npl/Icon/svgs/common/razorpay.svg": [
		21274,
		21274
	],
	"components/npl/Icon/svgs/common/receipt-check.svg": [
		9000,
		9000
	],
	"components/npl/Icon/svgs/common/receipt.svg": [
		24877,
		24877
	],
	"components/npl/Icon/svgs/common/recording-01.svg": [
		45021,
		45021
	],
	"components/npl/Icon/svgs/common/recording-02.svg": [
		2155,
		2155
	],
	"components/npl/Icon/svgs/common/recording-03.svg": [
		8234,
		8234
	],
	"components/npl/Icon/svgs/common/reduce-width.svg": [
		16226,
		16226
	],
	"components/npl/Icon/svgs/common/reflect-01.svg": [
		73919,
		73919
	],
	"components/npl/Icon/svgs/common/reflect-02.svg": [
		60017,
		60017
	],
	"components/npl/Icon/svgs/common/refresh-ccw-01.svg": [
		98749,
		98749
	],
	"components/npl/Icon/svgs/common/refresh-cw-01.svg": [
		45425,
		45425
	],
	"components/npl/Icon/svgs/common/refresh-cw-04.svg": [
		53248,
		53248
	],
	"components/npl/Icon/svgs/common/refresh-cw-05.svg": [
		77,
		77
	],
	"components/npl/Icon/svgs/common/reorder.svg": [
		3866,
		3866
	],
	"components/npl/Icon/svgs/common/repeat-01.svg": [
		55489,
		55489
	],
	"components/npl/Icon/svgs/common/repeat-02.svg": [
		40423,
		40423
	],
	"components/npl/Icon/svgs/common/right-indent-01.svg": [
		47741,
		47741
	],
	"components/npl/Icon/svgs/common/right-indent-02.svg": [
		2889,
		2889
	],
	"components/npl/Icon/svgs/common/rocket-02.svg": [
		72971,
		72971
	],
	"components/npl/Icon/svgs/common/roller-brush.svg": [
		83546,
		83546
	],
	"components/npl/Icon/svgs/common/route.svg": [
		65584,
		65584
	],
	"components/npl/Icon/svgs/common/rows-01.svg": [
		6263,
		6263
	],
	"components/npl/Icon/svgs/common/rows-02.svg": [
		65312,
		65312
	],
	"components/npl/Icon/svgs/common/rows-03.svg": [
		48472,
		48472
	],
	"components/npl/Icon/svgs/common/rss-01.svg": [
		13983,
		13983
	],
	"components/npl/Icon/svgs/common/ruler.svg": [
		44340,
		44340
	],
	"components/npl/Icon/svgs/common/safe.svg": [
		25870,
		25870
	],
	"components/npl/Icon/svgs/common/sale-01.svg": [
		81999,
		81999
	],
	"components/npl/Icon/svgs/common/sale-02.svg": [
		27484,
		27484
	],
	"components/npl/Icon/svgs/common/save-01.svg": [
		90676,
		90676
	],
	"components/npl/Icon/svgs/common/scale-01.svg": [
		6747,
		6747
	],
	"components/npl/Icon/svgs/common/scale-02.svg": [
		45688,
		45688
	],
	"components/npl/Icon/svgs/common/scale-03.svg": [
		683,
		683
	],
	"components/npl/Icon/svgs/common/scales-02.svg": [
		39503,
		39503
	],
	"components/npl/Icon/svgs/common/scan.svg": [
		66322,
		66322
	],
	"components/npl/Icon/svgs/common/scissors-01.svg": [
		10354,
		10354
	],
	"components/npl/Icon/svgs/common/scissors-cut-01.svg": [
		48285,
		48285
	],
	"components/npl/Icon/svgs/common/search-md.svg": [
		12998,
		12998
	],
	"components/npl/Icon/svgs/common/send-01.svg": [
		36855,
		36855
	],
	"components/npl/Icon/svgs/common/send-03.svg": [
		68754,
		68754
	],
	"components/npl/Icon/svgs/common/send-first-01.svg": [
		70734,
		70734
	],
	"components/npl/Icon/svgs/common/send-magic-01.svg": [
		62312,
		62312
	],
	"components/npl/Icon/svgs/common/send-magic-03.svg": [
		31207,
		31207
	],
	"components/npl/Icon/svgs/common/send-second-01.svg": [
		15936,
		15936
	],
	"components/npl/Icon/svgs/common/server-01.svg": [
		16252,
		65063
	],
	"components/npl/Icon/svgs/common/server-02.svg": [
		6619,
		6619
	],
	"components/npl/Icon/svgs/common/server-03.svg": [
		11214,
		11214
	],
	"components/npl/Icon/svgs/common/server-04.svg": [
		56396,
		56396
	],
	"components/npl/Icon/svgs/common/server-05.svg": [
		80619,
		80619
	],
	"components/npl/Icon/svgs/common/server-06.svg": [
		87901,
		87901
	],
	"components/npl/Icon/svgs/common/settings-01.svg": [
		73634,
		73634
	],
	"components/npl/Icon/svgs/common/settings-04.svg": [
		11823,
		11823
	],
	"components/npl/Icon/svgs/common/share-01.svg": [
		81512,
		81512
	],
	"components/npl/Icon/svgs/common/share-android.svg": [
		64591,
		64591
	],
	"components/npl/Icon/svgs/common/share-forward.svg": [
		64957,
		64957
	],
	"components/npl/Icon/svgs/common/shield-01.svg": [
		77189,
		1539
	],
	"components/npl/Icon/svgs/common/shield-dollar.svg": [
		40949,
		40949
	],
	"components/npl/Icon/svgs/common/shield-off.svg": [
		85816,
		85816
	],
	"components/npl/Icon/svgs/common/shield-plus.svg": [
		83624,
		83624
	],
	"components/npl/Icon/svgs/common/shield-tick.svg": [
		46147,
		46147
	],
	"components/npl/Icon/svgs/common/shield-zap.svg": [
		95447,
		95447
	],
	"components/npl/Icon/svgs/common/shopping-bag-01.svg": [
		55049,
		55049
	],
	"components/npl/Icon/svgs/common/shopping-bag-02.svg": [
		24105,
		24105
	],
	"components/npl/Icon/svgs/common/shopping-cart-01.svg": [
		71364,
		71364
	],
	"components/npl/Icon/svgs/common/shuffle-01.svg": [
		26028,
		26028
	],
	"components/npl/Icon/svgs/common/signal-01.svg": [
		97006,
		97006
	],
	"components/npl/Icon/svgs/common/signal-02.svg": [
		1363,
		1363
	],
	"components/npl/Icon/svgs/common/signal-03.svg": [
		51059,
		51059
	],
	"components/npl/Icon/svgs/common/simcard.svg": [
		70774,
		70774
	],
	"components/npl/Icon/svgs/common/skew.svg": [
		18747,
		18747
	],
	"components/npl/Icon/svgs/common/skip-back.svg": [
		91035,
		91035
	],
	"components/npl/Icon/svgs/common/skip-forward.svg": [
		63972,
		63972
	],
	"components/npl/Icon/svgs/common/slash-circle-01.svg": [
		55497,
		55497
	],
	"components/npl/Icon/svgs/common/sliders-01.svg": [
		17473,
		17473
	],
	"components/npl/Icon/svgs/common/snowflake-01.svg": [
		28167,
		28167
	],
	"components/npl/Icon/svgs/common/snowflake-02.svg": [
		72634,
		72634
	],
	"components/npl/Icon/svgs/common/spacing-height-01.svg": [
		53252,
		53252
	],
	"components/npl/Icon/svgs/common/spacing-height-02.svg": [
		50218,
		50218
	],
	"components/npl/Icon/svgs/common/spacing-width-01.svg": [
		95458,
		95458
	],
	"components/npl/Icon/svgs/common/spacing-width-02.svg": [
		31719,
		31719
	],
	"components/npl/Icon/svgs/common/speaker-01.svg": [
		81932,
		81932
	],
	"components/npl/Icon/svgs/common/speaker-02.svg": [
		88206,
		88206
	],
	"components/npl/Icon/svgs/common/speedometer-01.svg": [
		99839,
		99839
	],
	"components/npl/Icon/svgs/common/speedometer-03.svg": [
		85278,
		85278
	],
	"components/npl/Icon/svgs/common/spinning-wheel.svg": [
		95769,
		95769
	],
	"components/npl/Icon/svgs/common/square.svg": [
		88561,
		88561
	],
	"components/npl/Icon/svgs/common/stand.svg": [
		30857,
		30857
	],
	"components/npl/Icon/svgs/common/star-04.svg": [
		64062,
		64062
	],
	"components/npl/Icon/svgs/common/star-05.svg": [
		35279,
		35279
	],
	"components/npl/Icon/svgs/common/star-06.svg": [
		65618,
		65618
	],
	"components/npl/Icon/svgs/common/star-07.svg": [
		29795,
		29795
	],
	"components/npl/Icon/svgs/common/stars-01.svg": [
		54173,
		54173
	],
	"components/npl/Icon/svgs/common/stars-02.svg": [
		49289,
		49289
	],
	"components/npl/Icon/svgs/common/stars-03.svg": [
		85390,
		85390
	],
	"components/npl/Icon/svgs/common/stars-filled-01.svg": [
		62630,
		62630
	],
	"components/npl/Icon/svgs/common/stars-filled-02.svg": [
		98204,
		98204
	],
	"components/npl/Icon/svgs/common/sticker-circle.svg": [
		23540,
		23540
	],
	"components/npl/Icon/svgs/common/sticker-square.svg": [
		69996,
		69996
	],
	"components/npl/Icon/svgs/common/stop-circle.svg": [
		75136,
		75136
	],
	"components/npl/Icon/svgs/common/stop-filled.svg": [
		63887,
		63887
	],
	"components/npl/Icon/svgs/common/stop-square.svg": [
		21813,
		21813
	],
	"components/npl/Icon/svgs/common/stop.svg": [
		15572,
		15572
	],
	"components/npl/Icon/svgs/common/strikethrough-01.svg": [
		6849,
		6849
	],
	"components/npl/Icon/svgs/common/subscript.svg": [
		35673,
		35673
	],
	"components/npl/Icon/svgs/common/sun-setting-01.svg": [
		79166,
		79166
	],
	"components/npl/Icon/svgs/common/sun-setting-03.svg": [
		30237,
		30237
	],
	"components/npl/Icon/svgs/common/sun.svg": [
		95013,
		95013
	],
	"components/npl/Icon/svgs/common/sunrise.svg": [
		80858,
		80858
	],
	"components/npl/Icon/svgs/common/sunset.svg": [
		6194,
		6194
	],
	"components/npl/Icon/svgs/common/switch-horizontal-01.svg": [
		37407,
		37407
	],
	"components/npl/Icon/svgs/common/switch-horizontal-02.svg": [
		13710,
		13710
	],
	"components/npl/Icon/svgs/common/switch-vertical-01.svg": [
		90495,
		90495
	],
	"components/npl/Icon/svgs/common/switch-vertical-02.svg": [
		47935,
		47935
	],
	"components/npl/Icon/svgs/common/table.svg": [
		13687,
		13687
	],
	"components/npl/Icon/svgs/common/tablet-01.svg": [
		20177,
		20177
	],
	"components/npl/Icon/svgs/common/tag-01.svg": [
		78512,
		78512
	],
	"components/npl/Icon/svgs/common/target-02.svg": [
		56517,
		56517
	],
	"components/npl/Icon/svgs/common/target-04.svg": [
		42253,
		42253
	],
	"components/npl/Icon/svgs/common/telescope.svg": [
		59548,
		59548
	],
	"components/npl/Icon/svgs/common/terminal-browser.svg": [
		63658,
		63658
	],
	"components/npl/Icon/svgs/common/terminal-circle.svg": [
		24567,
		24567
	],
	"components/npl/Icon/svgs/common/terminal-square.svg": [
		31898,
		31898
	],
	"components/npl/Icon/svgs/common/terminal.svg": [
		10419,
		10419
	],
	"components/npl/Icon/svgs/common/text-input.svg": [
		43503,
		43503
	],
	"components/npl/Icon/svgs/common/thermometer-01.svg": [
		44868,
		44868
	],
	"components/npl/Icon/svgs/common/thermometer-02.svg": [
		13551,
		13551
	],
	"components/npl/Icon/svgs/common/thermometer-03.svg": [
		44698,
		44698
	],
	"components/npl/Icon/svgs/common/thermometer-cold.svg": [
		16230,
		16230
	],
	"components/npl/Icon/svgs/common/thermometer-warm.svg": [
		57989,
		57989
	],
	"components/npl/Icon/svgs/common/thumbs-down.svg": [
		22588,
		22588
	],
	"components/npl/Icon/svgs/common/thumbs-up.svg": [
		94087,
		94087
	],
	"components/npl/Icon/svgs/common/tick.svg": [
		47158,
		47158
	],
	"components/npl/Icon/svgs/common/ticket-01.svg": [
		76759,
		76759
	],
	"components/npl/Icon/svgs/common/token-gate.svg": [
		95694,
		95694
	],
	"components/npl/Icon/svgs/common/tool-01.svg": [
		94894,
		94894
	],
	"components/npl/Icon/svgs/common/tool-02.svg": [
		15022,
		15022
	],
	"components/npl/Icon/svgs/common/train.svg": [
		6668,
		6668
	],
	"components/npl/Icon/svgs/common/tram.svg": [
		96261,
		96261
	],
	"components/npl/Icon/svgs/common/transform.svg": [
		68469,
		40522
	],
	"components/npl/Icon/svgs/common/translate-01.svg": [
		66805,
		66805
	],
	"components/npl/Icon/svgs/common/trash-01.svg": [
		78225,
		78225
	],
	"components/npl/Icon/svgs/common/trend-down-01.svg": [
		17785,
		17785
	],
	"components/npl/Icon/svgs/common/trend-up-01.svg": [
		47311,
		47311
	],
	"components/npl/Icon/svgs/common/triangle.svg": [
		33439,
		80531
	],
	"components/npl/Icon/svgs/common/trophy-01.svg": [
		12737,
		12737
	],
	"components/npl/Icon/svgs/common/truck-02.svg": [
		25219,
		25219
	],
	"components/npl/Icon/svgs/common/tv-02.svg": [
		18258,
		18258
	],
	"components/npl/Icon/svgs/common/type-01.svg": [
		17540,
		17540
	],
	"components/npl/Icon/svgs/common/type-strikethrough-01.svg": [
		25468,
		25468
	],
	"components/npl/Icon/svgs/common/umbrella-02.svg": [
		74876,
		74876
	],
	"components/npl/Icon/svgs/common/umbrella-03.svg": [
		44565,
		44565
	],
	"components/npl/Icon/svgs/common/underline-01.svg": [
		63871,
		63871
	],
	"components/npl/Icon/svgs/common/unfeature.svg": [
		33391,
		33391
	],
	"components/npl/Icon/svgs/common/unpin-filled.svg": [
		10151,
		10151
	],
	"components/npl/Icon/svgs/common/unpin.svg": [
		82248,
		82248
	],
	"components/npl/Icon/svgs/common/upload-cloud-01.svg": [
		26446,
		26446
	],
	"components/npl/Icon/svgs/common/usb-flash-drive.svg": [
		36339,
		36339
	],
	"components/npl/Icon/svgs/common/user-01.svg": [
		6133,
		6133
	],
	"components/npl/Icon/svgs/common/user-check-01.svg": [
		60980,
		60980
	],
	"components/npl/Icon/svgs/common/user-circle.svg": [
		34561,
		34561
	],
	"components/npl/Icon/svgs/common/user-down-01.svg": [
		2854,
		2854
	],
	"components/npl/Icon/svgs/common/user-edit.svg": [
		85564,
		85564
	],
	"components/npl/Icon/svgs/common/user-left-01.svg": [
		25869,
		25869
	],
	"components/npl/Icon/svgs/common/user-minus-01.svg": [
		97106,
		97106
	],
	"components/npl/Icon/svgs/common/user-money.svg": [
		7452,
		7452
	],
	"components/npl/Icon/svgs/common/user-plus-01.svg": [
		89122,
		89122
	],
	"components/npl/Icon/svgs/common/user-right-01.svg": [
		47243,
		47243
	],
	"components/npl/Icon/svgs/common/user-square.svg": [
		1352,
		1352
	],
	"components/npl/Icon/svgs/common/user-up-01.svg": [
		50700,
		50700
	],
	"components/npl/Icon/svgs/common/user-x-01.svg": [
		91672,
		91672
	],
	"components/npl/Icon/svgs/common/users-01.svg": [
		59913,
		59913
	],
	"components/npl/Icon/svgs/common/users-check.svg": [
		58369,
		58369
	],
	"components/npl/Icon/svgs/common/users-download.svg": [
		70618,
		70618
	],
	"components/npl/Icon/svgs/common/users-edit.svg": [
		82747,
		13572
	],
	"components/npl/Icon/svgs/common/users-left.svg": [
		98080,
		98080
	],
	"components/npl/Icon/svgs/common/users-minus.svg": [
		69561,
		69561
	],
	"components/npl/Icon/svgs/common/users-money.svg": [
		20316,
		20316
	],
	"components/npl/Icon/svgs/common/users-plus.svg": [
		60645,
		60645
	],
	"components/npl/Icon/svgs/common/users-right.svg": [
		77621,
		77621
	],
	"components/npl/Icon/svgs/common/users-up.svg": [
		59663,
		59663
	],
	"components/npl/Icon/svgs/common/users-x.svg": [
		82769,
		82769
	],
	"components/npl/Icon/svgs/common/variable.svg": [
		16300,
		16300
	],
	"components/npl/Icon/svgs/common/video-courses.svg": [
		10115,
		10115
	],
	"components/npl/Icon/svgs/common/video-recorder-off.svg": [
		42298,
		42298
	],
	"components/npl/Icon/svgs/common/video-recorder.svg": [
		46854,
		46854
	],
	"components/npl/Icon/svgs/common/voicemail.svg": [
		13932,
		13932
	],
	"components/npl/Icon/svgs/common/volume-max.svg": [
		1940,
		1940
	],
	"components/npl/Icon/svgs/common/volume-min.svg": [
		4380,
		4380
	],
	"components/npl/Icon/svgs/common/volume-minus.svg": [
		22565,
		22565
	],
	"components/npl/Icon/svgs/common/volume-plus.svg": [
		87113,
		87113
	],
	"components/npl/Icon/svgs/common/volume-x.svg": [
		82699,
		82699
	],
	"components/npl/Icon/svgs/common/wallet-01.svg": [
		62750,
		62750
	],
	"components/npl/Icon/svgs/common/wallet-02.svg": [
		20822,
		20822
	],
	"components/npl/Icon/svgs/common/watch-circle.svg": [
		37741,
		37741
	],
	"components/npl/Icon/svgs/common/waves.svg": [
		10370,
		10370
	],
	"components/npl/Icon/svgs/common/waving-hand.svg": [
		24601,
		24601
	],
	"components/npl/Icon/svgs/common/wifi-off.svg": [
		4276,
		4276
	],
	"components/npl/Icon/svgs/common/wifi.svg": [
		8997,
		8997
	],
	"components/npl/Icon/svgs/common/wind-01.svg": [
		95680,
		95680
	],
	"components/npl/Icon/svgs/common/wind-02.svg": [
		21109,
		21109
	],
	"components/npl/Icon/svgs/common/wind-03.svg": [
		87649,
		87649
	],
	"components/npl/Icon/svgs/common/x-circle-filled.svg": [
		71157,
		71157
	],
	"components/npl/Icon/svgs/common/x-circle.svg": [
		65853,
		65853
	],
	"components/npl/Icon/svgs/common/x-close.svg": [
		7641,
		7641
	],
	"components/npl/Icon/svgs/common/youtube.svg": [
		22851,
		22851
	],
	"components/npl/Icon/svgs/common/zap-fast.svg": [
		95169,
		95169
	],
	"components/npl/Icon/svgs/common/zap-off.svg": [
		35682,
		35682
	],
	"components/npl/Icon/svgs/common/zap.svg": [
		51072,
		51072
	],
	"components/npl/Icon/svgs/common/zoom-in.svg": [
		58241,
		58241
	],
	"components/npl/Icon/svgs/common/zoom-out.svg": [
		61336,
		29246
	],
	"components/npl/Icon/svgs/country/aed.svg": [
		21289,
		21289
	],
	"components/npl/Icon/svgs/country/ars.svg": [
		30736,
		30736
	],
	"components/npl/Icon/svgs/country/aud.svg": [
		20950,
		20950
	],
	"components/npl/Icon/svgs/country/brl.svg": [
		55804,
		55804
	],
	"components/npl/Icon/svgs/country/cad.svg": [
		7082,
		7082
	],
	"components/npl/Icon/svgs/country/clp.svg": [
		83795,
		83795
	],
	"components/npl/Icon/svgs/country/cop.svg": [
		1695,
		82747
	],
	"components/npl/Icon/svgs/country/eur.svg": [
		16183,
		16183
	],
	"components/npl/Icon/svgs/country/gbp.svg": [
		39707,
		39707
	],
	"components/npl/Icon/svgs/country/huf.svg": [
		1610,
		8936
	],
	"components/npl/Icon/svgs/country/idr.svg": [
		15870,
		15870
	],
	"components/npl/Icon/svgs/country/ils.svg": [
		3388,
		3388
	],
	"components/npl/Icon/svgs/country/inr.svg": [
		29376,
		29376
	],
	"components/npl/Icon/svgs/country/jpy.svg": [
		59468,
		59468
	],
	"components/npl/Icon/svgs/country/mxn.svg": [
		20665,
		20665
	],
	"components/npl/Icon/svgs/country/myr.svg": [
		61114,
		61114
	],
	"components/npl/Icon/svgs/country/pen.svg": [
		93800,
		93800
	],
	"components/npl/Icon/svgs/country/php.svg": [
		65148,
		65148
	],
	"components/npl/Icon/svgs/country/sgd.svg": [
		47652,
		47652
	],
	"components/npl/Icon/svgs/country/usd.svg": [
		68987,
		68987
	],
	"components/npl/Icon/svgs/country/uyu.svg": [
		10765,
		10765
	],
	"components/npl/Icon/svgs/logo/nas-io-logo-coloured.svg": [
		17211,
		17211
	],
	"components/npl/Icon/svgs/logo/nas-io-logo-grayscale.svg": [
		2543,
		2543
	],
	"components/npl/Icon/svgs/logo/nas-io-logo-with-text-coloured.svg": [
		55304,
		55304
	],
	"components/npl/Icon/svgs/logo/nas-io-logo-with-text-grayscale.svg": [
		30310,
		30310
	],
	"components/npl/Icon/svgs/logo/nas-io-logo-with-text-white.svg": [
		38804,
		38804
	],
	"components/npl/Icon/svgs/payment-methods/alipay.svg": [
		76034,
		76034
	],
	"components/npl/Icon/svgs/payment-methods/amazon.svg": [
		15260,
		15260
	],
	"components/npl/Icon/svgs/payment-methods/amex.svg": [
		4058,
		4058
	],
	"components/npl/Icon/svgs/payment-methods/applePay.svg": [
		19815,
		19815
	],
	"components/npl/Icon/svgs/payment-methods/bitPay.svg": [
		33135,
		33135
	],
	"components/npl/Icon/svgs/payment-methods/cabal.svg": [
		72644,
		72644
	],
	"components/npl/Icon/svgs/payment-methods/carnet.svg": [
		77758,
		77758
	],
	"components/npl/Icon/svgs/payment-methods/cmr.svg": [
		92430,
		92430
	],
	"components/npl/Icon/svgs/payment-methods/credit-card-02.svg": [
		50845,
		68588
	],
	"components/npl/Icon/svgs/payment-methods/credit-card-filled.svg": [
		48212,
		48212
	],
	"components/npl/Icon/svgs/payment-methods/diners.svg": [
		50038,
		50038
	],
	"components/npl/Icon/svgs/payment-methods/ebanx.svg": [
		37224,
		37224
	],
	"components/npl/Icon/svgs/payment-methods/ebanx_boleto.svg": [
		32234,
		32234
	],
	"components/npl/Icon/svgs/payment-methods/ebanx_card.svg": [
		68785,
		68785
	],
	"components/npl/Icon/svgs/payment-methods/ebanx_efecty.svg": [
		6326,
		6326
	],
	"components/npl/Icon/svgs/payment-methods/ebanx_grayscale.svg": [
		11592,
		11592
	],
	"components/npl/Icon/svgs/payment-methods/ebanx_mercado.svg": [
		8556,
		8556
	],
	"components/npl/Icon/svgs/payment-methods/ebanx_nequi.svg": [
		88002,
		88002
	],
	"components/npl/Icon/svgs/payment-methods/ebanx_nu.svg": [
		28311,
		28311
	],
	"components/npl/Icon/svgs/payment-methods/ebanx_oxxo.svg": [
		27692,
		27692
	],
	"components/npl/Icon/svgs/payment-methods/ebanx_pagoefectivo.svg": [
		56041,
		56041
	],
	"components/npl/Icon/svgs/payment-methods/ebanx_pix.svg": [
		87858,
		87858
	],
	"components/npl/Icon/svgs/payment-methods/ebanx_safetypay.svg": [
		80897,
		92354
	],
	"components/npl/Icon/svgs/payment-methods/ebanx_spei.svg": [
		50093,
		50093
	],
	"components/npl/Icon/svgs/payment-methods/elo.svg": [
		58481,
		58481
	],
	"components/npl/Icon/svgs/payment-methods/gCash.svg": [
		23521,
		23521
	],
	"components/npl/Icon/svgs/payment-methods/googlePay.svg": [
		76618,
		76618
	],
	"components/npl/Icon/svgs/payment-methods/googlePay2.svg": [
		75354,
		75354
	],
	"components/npl/Icon/svgs/payment-methods/grabPay.svg": [
		87976,
		87976
	],
	"components/npl/Icon/svgs/payment-methods/hipercard.svg": [
		1381,
		1381
	],
	"components/npl/Icon/svgs/payment-methods/jcb.svg": [
		68921,
		68921
	],
	"components/npl/Icon/svgs/payment-methods/maestro.svg": [
		55105,
		55105
	],
	"components/npl/Icon/svgs/payment-methods/mastercard-black.svg": [
		24029,
		24029
	],
	"components/npl/Icon/svgs/payment-methods/mastercard.svg": [
		8541,
		8541
	],
	"components/npl/Icon/svgs/payment-methods/naranja.svg": [
		65229,
		65229
	],
	"components/npl/Icon/svgs/payment-methods/payMaya.svg": [
		60781,
		60781
	],
	"components/npl/Icon/svgs/payment-methods/payTm.svg": [
		54552,
		54552
	],
	"components/npl/Icon/svgs/payment-methods/paypal-greyscale.svg": [
		80020,
		80020
	],
	"components/npl/Icon/svgs/payment-methods/paypal.svg": [
		30983,
		30983
	],
	"components/npl/Icon/svgs/payment-methods/paype.svg": [
		77740,
		77740
	],
	"components/npl/Icon/svgs/payment-methods/pix-full.svg": [
		99547,
		99547
	],
	"components/npl/Icon/svgs/payment-methods/pix.svg": [
		41523,
		41523
	],
	"components/npl/Icon/svgs/payment-methods/razorpay-icon-only.svg": [
		30402,
		30402
	],
	"components/npl/Icon/svgs/payment-methods/razorpay.svg": [
		2279,
		2279
	],
	"components/npl/Icon/svgs/payment-methods/razorpay_greyscale.svg": [
		81501,
		81501
	],
	"components/npl/Icon/svgs/payment-methods/shopeePay.svg": [
		5310,
		5310
	],
	"components/npl/Icon/svgs/payment-methods/sodexo.svg": [
		35195,
		35195
	],
	"components/npl/Icon/svgs/payment-methods/stripe-grayscale.svg": [
		62266,
		62266
	],
	"components/npl/Icon/svgs/payment-methods/stripe.svg": [
		710,
		90087
	],
	"components/npl/Icon/svgs/payment-methods/unionPay.svg": [
		56399,
		56399
	],
	"components/npl/Icon/svgs/payment-methods/upi-coloured.svg": [
		99474,
		99474
	],
	"components/npl/Icon/svgs/payment-methods/upi.svg": [
		3757,
		3757
	],
	"components/npl/Icon/svgs/payment-methods/visa.svg": [
		94414,
		94414
	],
	"components/npl/Icon/svgs/payment-methods/xendit.svg": [
		12751,
		12751
	],
	"components/npl/Icon/svgs/social/airbnb-coloured.svg": [
		73097,
		73097
	],
	"components/npl/Icon/svgs/social/airbnb-neutral.svg": [
		96934,
		96934
	],
	"components/npl/Icon/svgs/social/apple-neutral.svg": [
		33976,
		33976
	],
	"components/npl/Icon/svgs/social/coinbase-coloured.svg": [
		39965,
		39965
	],
	"components/npl/Icon/svgs/social/discord-coloured-circle.svg": [
		7831,
		7831
	],
	"components/npl/Icon/svgs/social/discord-coloured.svg": [
		32380,
		32380
	],
	"components/npl/Icon/svgs/social/discord-neutral.svg": [
		12109,
		12109
	],
	"components/npl/Icon/svgs/social/discord-role-coloured.svg": [
		36438,
		36438
	],
	"components/npl/Icon/svgs/social/dribbble-coloured.svg": [
		19199,
		19199
	],
	"components/npl/Icon/svgs/social/dribbble-neutral.svg": [
		4809,
		4809
	],
	"components/npl/Icon/svgs/social/facebook-coloured.svg": [
		28807,
		28807
	],
	"components/npl/Icon/svgs/social/facebook-neutral.svg": [
		73295,
		73295
	],
	"components/npl/Icon/svgs/social/google-calendar.svg": [
		38961,
		38961
	],
	"components/npl/Icon/svgs/social/google-coloured.svg": [
		55915,
		55915
	],
	"components/npl/Icon/svgs/social/google-neutral.svg": [
		49168,
		49168
	],
	"components/npl/Icon/svgs/social/instagram-coloured.svg": [
		24404,
		24404
	],
	"components/npl/Icon/svgs/social/instagram-neutral.svg": [
		52470,
		52470
	],
	"components/npl/Icon/svgs/social/line-coloured.svg": [
		24328,
		24328
	],
	"components/npl/Icon/svgs/social/line-neutral.svg": [
		66993,
		66993
	],
	"components/npl/Icon/svgs/social/linkedin-coloured.svg": [
		38473,
		38473
	],
	"components/npl/Icon/svgs/social/linkedin-neutral.svg": [
		1827,
		1827
	],
	"components/npl/Icon/svgs/social/medium-neutral.svg": [
		26662,
		26662
	],
	"components/npl/Icon/svgs/social/messenger-neutral.svg": [
		62132,
		62132
	],
	"components/npl/Icon/svgs/social/metamask-coloured.svg": [
		44056,
		44056
	],
	"components/npl/Icon/svgs/social/opensea-coloured.svg": [
		49074,
		49074
	],
	"components/npl/Icon/svgs/social/opensea-neutral.svg": [
		88500,
		88500
	],
	"components/npl/Icon/svgs/social/patreon-neutral.svg": [
		67005,
		67005
	],
	"components/npl/Icon/svgs/social/slack-coloured.svg": [
		22721,
		22721
	],
	"components/npl/Icon/svgs/social/slack-neutral.svg": [
		5897,
		5897
	],
	"components/npl/Icon/svgs/social/snapchat-neutral.svg": [
		62836,
		62836
	],
	"components/npl/Icon/svgs/social/solana-coloured.svg": [
		18970,
		18970
	],
	"components/npl/Icon/svgs/social/spotify-coloured.svg": [
		97179,
		97179
	],
	"components/npl/Icon/svgs/social/spotify-neutral.svg": [
		35383,
		35383
	],
	"components/npl/Icon/svgs/social/telegram-coloured.svg": [
		7324,
		7324
	],
	"components/npl/Icon/svgs/social/telegram-neutral.svg": [
		41269,
		41269
	],
	"components/npl/Icon/svgs/social/tiktok-coloured.svg": [
		43404,
		43404
	],
	"components/npl/Icon/svgs/social/tiktok-neutral.svg": [
		55924,
		55924
	],
	"components/npl/Icon/svgs/social/twitter-coloured.svg": [
		14054,
		14054
	],
	"components/npl/Icon/svgs/social/twitter-neutral.svg": [
		54469,
		54469
	],
	"components/npl/Icon/svgs/social/whatsapp-coloured.svg": [
		37580,
		37580
	],
	"components/npl/Icon/svgs/social/whatsapp-neutral.svg": [
		46798,
		46798
	],
	"components/npl/Icon/svgs/social/youtube-coloured.svg": [
		51000,
		51000
	],
	"components/npl/Icon/svgs/social/youtube-neutral.svg": [
		82734,
		82734
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 78909;
module.exports = webpackAsyncContext;